(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8449],{

/***/ 2017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




const IconLoading = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", null, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "currentColor",
    strokeWidth: 4
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  }));
};

const ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconLoading, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
  svgRef: ref
}, props)));
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 90358:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oauth/[...slug]",
      function () {
        return __webpack_require__(73117);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ButtonLink_ButtonLink; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(26167);
;// CONCATENATED MODULE: ./components/ButtonLink/styles.ts


var isDefault = (0,tailwindcss_classnames/* classnames */.d)("md:mx-2");
var disabledButton = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-light-grey-500", "bg-nzxt-light-grey-300", "cursor-not-allowed", "hover:text-nzxt-light-grey-500", "hover:bg-nzxt-light-grey-300");
var isActive = (0,tailwindcss_classnames/* classnames */.d)("opacity-100", "pointer-events-auto", "group");
var styles_button = function(customMargin, isDisabled) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)((0,_define_property/* default */.Z)({}, isDefault, !customMargin), (_obj = {}, (0,_define_property/* default */.Z)(_obj, disabledButton, isDisabled), (0,_define_property/* default */.Z)(_obj, isActive, !isDisabled), _obj), "min-w-max", "flex", "items-center", "font-medium", "cursor-pointer", "text-center", "justify-around", "transition", "whitespace-nowrap", "h-11");
};
var disabledLink = (0,tailwindcss_classnames/* classnames */.d)("!text-nzxt-light-grey-500", "cursor-not-allowed");
var linkBase = function(isDisabled) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)((_obj = {}, (0,_define_property/* default */.Z)(_obj, disabledLink, isDisabled), (0,_define_property/* default */.Z)(_obj, isActive, !isDisabled), _obj), "cursor-pointer", "underline-offset");
};
var buttonModeLight = {
    primary: (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-volt-400", "hover:bg-nzxt-volt-500", "px-4", "2xl:px-10", "min-w-120", "md:min-w-140", "rounded-md", "text-white", "active:bg-nzxt-volt-500"),
    secondary: (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-dark-grey-400", "hover:bg-nzxt-dark-grey-500", "active:bg-nzxt-dark-grey-700", "text-white", "px-4", "2xl:px-10", "min-w-120", "md:min-w-140", "rounded-md"),
    danger: (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-red-200", "text-white", "hover:bg-nzxt-red-100", "px-4", "2xl:px-10", "min-w-120", "md:min-w-140", "rounded-md")
};
var buttonModeDark = {
    primary: (0,tailwindcss_classnames/* classnames */.d)("border-white", "border-2", "text-white", "px-4", "2xl:px-10", "min-w-120", "md:min-w-140", "rounded-md"),
    secondary: (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-dark-grey-400", "hover:bg-nzxt-dark-grey-500", "text-white", "px-4", "2xl:px-10", "min-w-120", "md:min-w-140", "rounded-md", "active:bg-nzxt-dark-grey-700"),
    danger: (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-red-100", "text-white", "hover:bg-nzxt-red-200", "px-4", "2xl:px-10", "min-w-120", "md:min-w-140", "rounded-md")
};
var baseLinkLight = {
    primary: (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-volt-400", "hover:underline"),
    secondary: (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-dark-grey-400", "hover:underline"),
    tertiary: (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-blue-400", "hover:underline"),
    danger: (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-red-200", "hover:underline")
};
var baseLinkDark = {
    primary: (0,tailwindcss_classnames/* classnames */.d)("text-white", "hover:underline"),
    secondary: (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-dark-grey-400", "hover:underline"),
    tertiary: (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-blue-300", "hover:underline"),
    danger: (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-red-200", "hover:underline")
};

// EXTERNAL MODULE: ./components/ButtonLink/buttonStyles.module.css
var buttonStyles_module = __webpack_require__(14709);
var buttonStyles_module_default = /*#__PURE__*/__webpack_require__.n(buttonStyles_module);
;// CONCATENATED MODULE: ./components/ButtonLink/ButtonLink.tsx
/* eslint-disable react/jsx-no-useless-fragment */ 









var ButtonLink = function(_param) {
    var children = _param.children, buttonStyle = _param.buttonStyle, _className = _param.className, className = _className === void 0 ? "" : _className, _dark = _param.dark, dark = _dark === void 0 ? false : _dark, _internalLink = _param.internalLink, internalLink = _internalLink === void 0 ? false : _internalLink, href = _param.href, customMargin = _param.customMargin, disabled = _param.disabled, asButton = _param.asButton, noChevron = _param.noChevron, id = _param.id, dataTestId = _param.dataTestId, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "buttonStyle",
        "className",
        "dark",
        "internalLink",
        "href",
        "customMargin",
        "disabled",
        "asButton",
        "noChevron",
        "id",
        "dataTestId"
    ]);
    var buttonType = buttonStyle === "primary" || buttonStyle === "secondary" ? buttonStyle : "primary";
    var linkType = buttonStyle === "primary" || buttonStyle === "secondary" ? buttonStyle : "tertiary";
    var TestId;
    if (!dataTestId) {
        TestId = internalLink ? "internal-link-block" : "external-link-block";
    } else {
        TestId = dataTestId;
    }
    var composedClassNameButton = (0,react.useMemo)(function() {
        return (0,clsx_m/* default */.Z)(styles_button(customMargin, disabled), dark ? buttonModeDark[buttonType] : buttonModeLight[buttonType], className, (buttonStyles_module_default()).btn);
    }, [
        className,
        dark,
        disabled,
        customMargin,
        buttonType
    ]);
    var composedClassNameLink = (0,react.useMemo)(function() {
        return (0,clsx_m/* default */.Z)(linkBase(disabled), dark ? baseLinkDark[linkType] : baseLinkLight[linkType], className, (0,_define_property/* default */.Z)({}, (buttonStyles_module_default()).link, !noChevron));
    }, [
        linkType,
        className,
        dark,
        disabled,
        noChevron
    ]);
    var buttonClassName = asButton ? composedClassNameButton : composedClassNameLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: internalLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: buttonClassName
            }, rest), {
                id: id,
                "data-test-id": TestId,
                children: children
            }))
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            href: href,
            className: buttonClassName
        }, rest), {
            "data-test-id": TestId,
            children: children
        }))
    });
};
/* harmony default export */ var ButtonLink_ButtonLink = (/*#__PURE__*/(0,react.memo)(ButtonLink));

;// CONCATENATED MODULE: ./components/ButtonLink/index.ts



/***/ }),

/***/ 29618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ContentWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(26167);
;// CONCATENATED MODULE: ./components/ContentWrapper/styles.ts

var contentWrapper = (0,tailwindcss_classnames/* classnames */.d)("w-11/12", "lg:max-w-screen-lg", "xl:max-w-screen-xl", "2xl:max-w-screen-2xl", "mx-auto", "md:px-6", "lg:px-10", "xl:px-20");
/* harmony default export */ var styles = ((/* unused pure expression or super */ null && (contentWrapper)));

;// CONCATENATED MODULE: ./components/ContentWrapper/ContentWrapper.tsx








var ContentWrapper = function(_param) {
    var children = _param.children, className = _param.className, id = _param.id, fullBleed = _param.fullBleed, style = _param.style, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "id",
        "fullBleed",
        "style"
    ]);
    var composedClassName = (0,react.useMemo)(function() {
        return (0,clsx_m/* default */.Z)((0,_define_property/* default */.Z)({}, contentWrapper, !fullBleed), className);
    }, [
        className,
        fullBleed
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: composedClassName,
        id: id,
        style: style
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var ContentWrapper_ContentWrapper = (/*#__PURE__*/(0,react.memo)(ContentWrapper));

;// CONCATENATED MODULE: ./components/ContentWrapper/index.ts

/* harmony default export */ var components_ContentWrapper = (ContentWrapper_ContentWrapper);


/***/ }),

/***/ 35510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Head; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./node_modules/react-datocms/dist/esm/Seo/renderMetaTags.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function renderMetaTags(data) {
    return data.map(function (_a) {
        var tag = _a.tag, attributes = _a.attributes, content = _a.content;
        var key = [tag];
        if (attributes && 'property' in attributes) {
            key.push(attributes.property);
        }
        if (attributes && 'name' in attributes) {
            key.push(attributes.name);
        }
        if (attributes && 'rel' in attributes) {
            key.push(attributes.rel);
        }
        if (attributes && 'sizes' in attributes) {
            key.push(attributes.sizes);
        }
        var Tag = tag;
        return (react.createElement(Tag, __assign({ key: key.join('-') }, attributes), content));
    });
}
//# sourceMappingURL=renderMetaTags.js.map
// EXTERNAL MODULE: ./constants/index.ts + 15 modules
var constants = __webpack_require__(47041);
;// CONCATENATED MODULE: ./components/Head/Head.tsx








var buildLanguageAlternates = function(baseUrl, canonical) {
    var alts = constants/* SUPPORTED_LOCALES.map */.RFD.map(function(locale) {
        return {
            hrefLang: locale,
            href: canonical.replace(baseUrl, "".concat(baseUrl, "/").concat(locale))
        };
    });
    alts.push({
        hrefLang: "x-default",
        href: canonical
    });
    return alts;
};
var proxyOgImages = function(cmsData) {
    // eslint-disable-next-line security/detect-non-literal-regexp
    var regex = new RegExp("".concat("https://www.datocms-assets.com", "/"), "g");
    var headData = cmsData.map(function(tag) {
        if (tag.attributes && tag.attributes.name && tag.attributes.name === "twitter:image" || tag.attributes && tag.attributes.property && tag.attributes.property === "og:image") {
            // eslint-disable-next-line no-param-reassign
            tag.attributes.content = tag.attributes.content.replace(regex, "".concat("https://nzxt.com", "/assets/cms/"));
        }
        return tag;
    });
    return headData;
};
var HeadComponent = function(_param) /*#__PURE__*/ {
    var cmsData = _param.cmsData, baseUrl = _param.baseUrl, canonical = _param.canonical, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "cmsData",
        "baseUrl",
        "canonical"
    ]);
    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({
                canonical: canonical,
                languageAlternates: buildLanguageAlternates(baseUrl, canonical)
            }, rest)),
            cmsData && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: renderMetaTags(proxyOgImages(cmsData))
            })
        ]
    });
};
/* harmony default export */ var Head = (/*#__PURE__*/(0,react.memo)(HeadComponent));

;// CONCATENATED MODULE: ./components/Head/index.ts



/***/ }),

/***/ 21762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ IconSection_IconSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./framework/api/utils/maxify/index.ts + 5 modules
var maxify = __webpack_require__(55469);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 16 modules
var hooks = __webpack_require__(83307);
// EXTERNAL MODULE: ./components/IconDynamic/index.ts + 1 modules
var IconDynamic = __webpack_require__(55720);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconHeart.js
var IconHeart = __webpack_require__(25956);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconTestedwithCare.js
var IconTestedwithCare = __webpack_require__(47070);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/Icon2YearWarranty.js
var Icon2YearWarranty = __webpack_require__(1683);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconExpertlyBuilt.js
var IconExpertlyBuilt = __webpack_require__(41061);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconStep1.js
var IconStep1 = __webpack_require__(51402);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconStep2.js
var IconStep2 = __webpack_require__(20062);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconStep3.js
var IconStep3 = __webpack_require__(96520);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconGameSync.js
var IconGameSync = __webpack_require__(81178);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconSmartScheduling.js
var IconSmartScheduling = __webpack_require__(30481);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconRBGLEDStrips.js
var IconRBGLEDStrips = __webpack_require__(58853);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconCompleteCustomization.js
var IconCompleteCustomization = __webpack_require__(46261);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconSideGlasscasepanel.js
var IconSideGlasscasepanel = __webpack_require__(74480);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconAerFanRGB.js
var IconAerFanRGB = __webpack_require__(25361);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconH1.js
var IconH1 = __webpack_require__(12405);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconKrakenZ.js
var IconKrakenZ = __webpack_require__(4575);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconKrakenzpumps.js
var IconKrakenzpumps = __webpack_require__(58655);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconKraken.js
var IconKraken = __webpack_require__(47651);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconRadiatorSupportLarge.js
var IconRadiatorSupportLarge = __webpack_require__(62025);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconRadiatorSupport.js
var IconRadiatorSupport = __webpack_require__(40774);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconLighting.js
var IconLighting = __webpack_require__(18491);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconSettings2.js
var IconSettings2 = __webpack_require__(73611);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconIntegratedRearIO.js
var IconIntegratedRearIO = __webpack_require__(89089);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconPerformance2.js
var IconPerformance2 = __webpack_require__(64931);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconRGBCableComb.js
var IconRGBCableComb = __webpack_require__(66087);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconKrakenM22.js
var IconKrakenM22 = __webpack_require__(95488);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconReinforcedExtendedTubing.js
var IconReinforcedExtendedTubing = __webpack_require__(51732);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconWifi.js
var IconWifi = __webpack_require__(77128);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconMidTower.js
var IconMidTower = __webpack_require__(38654);
// EXTERNAL MODULE: ./components/ButtonLink/index.ts + 2 modules
var ButtonLink = __webpack_require__(82346);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(26167);
;// CONCATENATED MODULE: ./components/IconSection/styles.ts


var smallSizes = (0,tailwindcss_classnames/* classnames */.d)("w-12", "h-12", "lg:w-8", "lg:h-8");
var largeSizes = (0,tailwindcss_classnames/* classnames */.d)("w-12", "h-12");
var styles_buildSystem = function(isSmall) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)((_obj = {}, (0,src_define_property/* default */.Z)(_obj, smallSizes, isSmall), (0,src_define_property/* default */.Z)(_obj, largeSizes, !isSmall), _obj), "text-nzxt-dark-grey-500", "fill-current", "mx-auto", "col-span-1");
};
var sectionBg = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-light-grey-100", "lg:rounded-md", "py-8", "lg:py-12", "px-4", "w-full", "lg:max-w-screen-lg", "xl:max-w-screen-xl", "2xl:max-w-screen-2xl", "mx-auto", "lg:px-10", "xl:px-20", "mx-auto");
var iconSection = function(hasBg) {
    return (0,tailwindcss_classnames/* classnames */.d)("flex", "flex-col", "md:flex-row", "justify-center", "space-y-6", "md:space-y-0", "md:space-x-4", (0,src_define_property/* default */.Z)({}, sectionBg, hasBg));
};
var centerSmall = (0,tailwindcss_classnames/* classnames */.d)("items-center", "md:items-end");
var iconSectionItem = function(isSmall) {
    return (0,tailwindcss_classnames/* classnames */.d)((0,src_define_property/* default */.Z)({}, centerSmall, isSmall), "md:w-1/3", "px-2", "md:px-0", "md:pt-0", "w-full", "md:text-center", "md:flex", "md:flex-col", "items-center", "md:space-y-2", "grid", "grid-cols-4");
};
var smallText = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "px-4");
var defultText = (0,tailwindcss_classnames/* classnames */.d)("text-sm", "md:text-base", "px-2");
var deafultHeaderText = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "md:text-lg", "px-2");
var styles_text = function(isSmall) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-dark-grey-500", (_obj = {}, (0,src_define_property/* default */.Z)(_obj, smallText, isSmall), (0,src_define_property/* default */.Z)(_obj, defultText, !isSmall), _obj));
};
var heading = function(isSmall) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-dark-grey-800", "font-semibold", (_obj = {}, (0,src_define_property/* default */.Z)(_obj, smallText, isSmall), (0,src_define_property/* default */.Z)(_obj, deafultHeaderText, !isSmall), _obj));
};
var withBg = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-light-grey-100");
var noBg = (0,tailwindcss_classnames/* classnames */.d)("bg-transparent");
var getBg = function(hasBg) {
    var _obj;
    return classnames((_obj = {}, _define_property(_obj, withBg, hasBg), _define_property(_obj, noBg, !hasBg), _obj));
};
var textContainer = (0,tailwindcss_classnames/* classnames */.d)("col-span-3", "md:col-span-1", "md:mx-auto");

;// CONCATENATED MODULE: ./components/IconSection/IconSection.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 








// to do: icons need updating
var IconSection = function(param) {
    var data = param.data, isSmall = param.isSmall, hasBg = param.hasBg;
    var locale = (0,router.useRouter)().locale;
    var region = (0,maxify/* getRegion */.ur)(locale);
    var regionalIconData = (0,react.useMemo)(function() {
        return Array.isArray(data) ? data.filter(function(c) {
            var ref;
            return (ref = c.availableRegions) === null || ref === void 0 ? void 0 : ref.some(function(r) {
                return (r === null || r === void 0 ? void 0 : r.region) === region;
            });
        }) : null;
    }, [
        data,
        region
    ]);
    var iconData = (regionalIconData === null || regionalIconData === void 0 ? void 0 : regionalIconData.length) > 0 ? regionalIconData : data;
    var buildSystem = styles_buildSystem;
    var ICON_SECTION_MAP = {
        Heart: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconHeart/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        TestedwithCare: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTestedwithCare/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        TwoYearWarranty: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon2YearWarranty/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        ExpertlyBuilt: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconExpertlyBuilt/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Step1: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStep1/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Step2: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStep2/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Step3: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconStep3/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        GameSync: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGameSync/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        SmartScheduling: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSmartScheduling/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        RBGLEDStrips: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRBGLEDStrips/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        CompleteCustomization: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCompleteCustomization/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        SideGlasscasepanel: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSideGlasscasepanel/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        AerFanRGB: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAerFanRGB/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        H1: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconH1/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        KrakenZ: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconKrakenZ/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Krakenzpumps: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconKrakenzpumps/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Kraken: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconKraken/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        RadiatorSupportLarge: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRadiatorSupportLarge/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        RadiatorSupport: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRadiatorSupport/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Lighting: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLighting/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Settings2: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSettings2/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        RearIO: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconIntegratedRearIO/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Performance2: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPerformance2/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        RGBCableComb: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRGBCableComb/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        KrakenM22: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconKrakenM22/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Reinforced: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconReinforcedExtendedTubing/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        Wifi: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWifi/* default */.Z, {
            className: buildSystem(isSmall)
        }),
        MidTower: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMidTower/* default */.Z, {
            className: buildSystem(isSmall)
        })
    };
    var LEARN_LABEL = (0,hooks/* useTranslation */.$G)("learn_more");
    return Array.isArray(iconData) && (iconData === null || iconData === void 0 ? void 0 : iconData.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: iconSection(hasBg),
        children: iconData === null || iconData === void 0 ? void 0 : iconData.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: iconSectionItem(isSmall),
                "data-test-id": "icon-subblock",
                children: [
                    item.iconName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconDynamic/* default */.Z, {
                        iconName: item.iconName,
                        className: buildSystem(isSmall)
                    }) : ICON_SECTION_MAP[item.iconComponent],
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: textContainer,
                        children: [
                            item.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: heading(isSmall),
                                "data-test-id": "icon-block-title",
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: styles_text(isSmall),
                                "data-test-id": "icon-block-text",
                                children: item.text
                            }),
                            item.link && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                href: item.link,
                                children: LEARN_LABEL
                            })
                        ]
                    })
                ]
            }, item.text);
        })
    }) : null;
};
/* harmony default export */ var IconSection_IconSection = (/*#__PURE__*/(0,react.memo)(IconSection));

;// CONCATENATED MODULE: ./components/IconSection/index.ts



/***/ }),

/***/ 74871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SectionWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(26167);
;// CONCATENATED MODULE: ./components/SectionWrapper/styles.ts

var sectionWrapper = (0,tailwindcss_classnames/* classnames */.d)("py-6", "md:py-12", "xl:py-16");
/* harmony default export */ var styles = ((/* unused pure expression or super */ null && (sectionWrapper)));

;// CONCATENATED MODULE: ./components/SectionWrapper/SectionWrapper.tsx
/* eslint-disable no-nested-ternary */ 






var SectionWrapper = function(_param) {
    var children = _param.children, className = _param.className, id = _param.id, ref = _param.ref, style = _param.style, _noSpacing = _param.noSpacing, noSpacing = _noSpacing === void 0 ? false : _noSpacing, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "id",
        "ref",
        "style",
        "noSpacing"
    ]);
    var composedClassName = (0,react.useMemo)(function() {
        return !noSpacing ? (0,clsx_m/* default */.Z)(sectionWrapper, className) : className ? (0,clsx_m/* default */.Z)(className) : null;
    }, [
        className,
        noSpacing
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        className: composedClassName,
        id: id
    }, rest), {
        style: style,
        children: children
    }));
};
/* harmony default export */ var SectionWrapper_SectionWrapper = (/*#__PURE__*/(0,react.memo)(SectionWrapper));

;// CONCATENATED MODULE: ./components/SectionWrapper/index.ts

/* harmony default export */ var components_SectionWrapper = (SectionWrapper_SectionWrapper);


/***/ }),

/***/ 73117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(12918);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconLoading.js
var IconLoading = __webpack_require__(2017);
// EXTERNAL MODULE: ./components/Head/index.ts + 2 modules
var Head = __webpack_require__(35510);
// EXTERNAL MODULE: ./components/Layout/index.ts + 89 modules
var Layout = __webpack_require__(56696);
// EXTERNAL MODULE: ./components/ContentWrapper/index.ts + 2 modules
var components_ContentWrapper = __webpack_require__(29618);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Image/index.tsx + 2 modules
var components_Image = __webpack_require__(39953);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(26167);
;// CONCATENATED MODULE: ./components/CollectionPage/Hero/styles.ts

var centeredItems = (0,tailwindcss_classnames/* classnames */.d)("mx-auto", "flex", "flex-col", "justify-center", "items-center");
var heading = (0,tailwindcss_classnames/* classnames */.d)("border-b-2", "pb-4", "mb-4", "text-gradient", "bg-gradient-to-t", "to-nzxt-light-grey-500", "from-nzxt-light-grey-800", "text-4xl", "md:text-7xl", "h1", "text-center");
var subheading = (0,tailwindcss_classnames/* classnames */.d)("pb-6", "md:pb-12", "font-semibold", "md:text-lg", "text-lg", "text-center", "text-nzxt-light-grey-800", "w-11/12", "md:max-w-4xl");

;// CONCATENATED MODULE: ./components/CollectionPage/Hero/Hero.tsx





var Hero_Hero = function(param) {
    var heading = param.heading, image = param.image, subheading = param.subheading;
    return /*#__PURE__*/ _jsxs(ContentWrapper, {
        "data-test-id": "hero-content",
        className: styles.centeredItems,
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: styles.heading,
                "data-test-id": "hero-heading",
                children: heading
            }),
            /*#__PURE__*/ _jsx("p", {
                className: styles.subheading,
                "data-test-id": "hero-subheading",
                children: subheading
            }),
            image && /*#__PURE__*/ _jsx(Image, {
                data: image.responsiveImage,
                width: image.responsiveImage.width,
                height: image.responsiveImage.height,
                loading: "eager"
            })
        ]
    });
};
/* harmony default export */ var CollectionPage_Hero_Hero = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(Hero_Hero))));

;// CONCATENATED MODULE: ./components/CollectionPage/Hero/index.ts

/* harmony default export */ var CollectionPage_Hero = ((/* unused pure expression or super */ null && (Hero)));

// EXTERNAL MODULE: ./framework/api/utils/maxify/index.ts + 5 modules
var maxify = __webpack_require__(55469);
// EXTERNAL MODULE: ./constants/index.ts + 15 modules
var constants = __webpack_require__(47041);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 16 modules
var hooks = __webpack_require__(83307);
// EXTERNAL MODULE: ./components/ButtonLink/index.ts + 2 modules
var components_ButtonLink = __webpack_require__(82346);
// EXTERNAL MODULE: ./framework/commerce/index.tsx
var commerce = __webpack_require__(84634);
;// CONCATENATED MODULE: ./framework/commerce/use-price.tsx
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ 

function formatPrice(param) {
    var amount = param.amount, currencyCode = param.currencyCode, locale = param.locale, _maximumSignificantDigits = param.maximumSignificantDigits, maximumSignificantDigits = _maximumSignificantDigits === void 0 ? null : _maximumSignificantDigits;
    var opts = {
        style: "currency",
        currency: currencyCode
    };
    if (maximumSignificantDigits) {
        opts.maximumSignificantDigits = maximumSignificantDigits;
    }
    var formatCurrency = new Intl.NumberFormat(locale, opts);
    return formatCurrency.format(amount);
}
function formatVariantPrice(param) {
    var amount = param.amount, baseAmount = param.baseAmount, currencyCode = param.currencyCode, locale = param.locale, maximumSignificantDigits = param.maximumSignificantDigits;
    var hasDiscount = baseAmount > amount;
    var formatDiscount = new Intl.NumberFormat(locale, {
        style: "percent"
    });
    var discount = hasDiscount ? formatDiscount.format((baseAmount - amount) / baseAmount) : null;
    var price = formatPrice({
        amount: amount,
        currencyCode: currencyCode,
        locale: locale,
        maximumSignificantDigits: maximumSignificantDigits
    });
    var basePrice = hasDiscount ? formatPrice({
        amount: baseAmount,
        currencyCode: currencyCode,
        locale: locale,
        maximumSignificantDigits: maximumSignificantDigits
    }) : null;
    return {
        price: price,
        basePrice: basePrice,
        discount: discount
    };
}
function use_price_usePrice(data) {
    var ref = data !== null && data !== void 0 ? data : {}, amount = ref.amount, baseAmount = ref.baseAmount, currencyCode = ref.currencyCode, maximumSignificantDigits = ref.maximumSignificantDigits;
    var locale = useCommerce().locale;
    var value = useMemo(function() {
        if (typeof amount !== "number" || !currencyCode) return "";
        return baseAmount ? formatVariantPrice({
            amount: amount,
            baseAmount: baseAmount,
            currencyCode: currencyCode,
            locale: locale,
            maximumSignificantDigits: maximumSignificantDigits
        }) : formatPrice({
            amount: amount,
            currencyCode: currencyCode,
            locale: locale,
            maximumSignificantDigits: maximumSignificantDigits
        });
    }, [
        amount,
        baseAmount,
        currencyCode,
        locale,
        maximumSignificantDigits
    ]);
    return typeof value === "string" ? {
        price: value
    } : value;
};

;// CONCATENATED MODULE: ./framework/use-price.tsx



;// CONCATENATED MODULE: ./components/CollectionPage/ComparisonTable/Table/styles.ts


// sr-only
var srOnly = (0,tailwindcss_classnames/* classnames */.d)("sr-only");
// cell item
var tdSpacing = (0,tailwindcss_classnames/* classnames */.d)("py-5", "pr-4", "lg:py-5", "lg:px-6", "text-nzxt-light-grey-800", "text-center");
var svgStyles = (0,tailwindcss_classnames/* classnames */.d)("h-5", "w-5", "mx-auto");
var svgCheckStyles = (0,tailwindcss_classnames/* classnames */.d)(svgStyles, "text-nzxt-green-400");
var svgXStyles = (0,tailwindcss_classnames/* classnames */.d)(svgStyles, "text-nzxt-red-400");
// data section
var scrollDataTableHeadings = (0,tailwindcss_classnames/* classnames */.d)("sticky", "left-0", "bg-nzxt-light-grey-50");
var scrollDataTableHeadingsFaux = (0,tailwindcss_classnames/* classnames */.d)("sticky", "left-0");
var dataTableHeadings = function(isScroll) {
    return classnames("py-5", "px-6", "text-sm", "font-normal", "text-left", "text-nzxt-light-grey-600", _define_property({}, scrollDataTableHeadings, isScroll));
};
var dataTableHeadingsFaux = function(isScroll) {
    return classnames("py-5", "px-6", "text-sm", "font-normal", "text-left", "text-nzxt-light-grey-600", "invisible", _define_property({}, scrollDataTableHeadingsFaux, isScroll));
};
// product section
var scrollProductSectionImage = (0,tailwindcss_classnames/* classnames */.d)("w-48", "md:w-80", "mb-4");
var scrollProductTableHeading = (0,tailwindcss_classnames/* classnames */.d)(scrollDataTableHeadings, "block", "w-32", "md:w-56", "h-full", "z-10", "flex", "justify-end", "items-end");
var productTableHeading = function(isScroll) {
    return classnames("py-8", "px-6", "text-sm", "font-medium", "text-right", _define_property({}, scrollProductTableHeading, isScroll));
};
var productTableData = (0,tailwindcss_classnames/* classnames */.d)("py-8", "px-6", "h-full", "align-top");
var productWrapper = (0,tailwindcss_classnames/* classnames */.d)("relative", "table", "h-full");
var productSubheading = (0,tailwindcss_classnames/* classnames */.d)("text-sm", "text-nzxt-light-grey-600");
var productPrice = (0,tailwindcss_classnames/* classnames */.d)("mb-4", "text-center");
var productButtons = (0,tailwindcss_classnames/* classnames */.d)("text-sm", "font-semibold", "text-white", "text-center", "hover:bg-gray-900", "py-2", "rounded-md", "bg-gray-800", "w-full", "block", "flex-grow", "bottom-0", "absolute");
// head section
var scrollspacingHeader = (0,tailwindcss_classnames/* classnames */.d)("sticky", "left-0", "bg-nzxt-light-grey-50");
var spacingHeader = function(isScroll) {
    return classnames("pb-4", "px-6", _define_property({}, scrollspacingHeader, isScroll));
};
var headingHeader = (0,tailwindcss_classnames/* classnames */.d)("mb-2", "mt-2", "text-center", "text-2xl", "md:text-3xl", "font-bold", "leading-relaxed", "text-nzxt-light-grey-800");
var headingSubtype = (0,tailwindcss_classnames/* classnames */.d)("font-thin");
// table
var tableBody = (0,tailwindcss_classnames/* classnames */.d)("divide-y", "divide-gray-200");
var largeTable = (0,tailwindcss_classnames/* classnames */.d)("w-full", "h-px", "table-fixed", "hidden", "lg:table");
// single item
var specsSection = (0,tailwindcss_classnames/* classnames */.d)("grid", "grid-cols-12", "gap-2", "md:gap-2", "text-nzxt-light-grey-800", "border-t", "pt-2");
var specsWrapper = (0,tailwindcss_classnames/* classnames */.d)("pt-4", "pb-6", "md:grid", "md:grid-cols-4", "block", "justify-between", "md:col-span-6", "col-span-12", "border-b");
// inner
var specValueDetail = (0,tailwindcss_classnames/* classnames */.d)("col-span-2");
var specCategory = (0,tailwindcss_classnames/* classnames */.d)("font-semibold", "text-nzxt-light-grey-600", "col-span-2");
var singleItemWrapper = (0,tailwindcss_classnames/* classnames */.d)("flex", "flex-col", "justify-center", "items-center", "text-center");
var singleItemImgWrapper = (0,tailwindcss_classnames/* classnames */.d)("max-w-xs", "mx-auto");
var singleItemProductSubheading = (0,tailwindcss_classnames/* classnames */.d)("text-sm", "text-nzxt-light-grey-600", "text-center");
var priceStyles = (0,tailwindcss_classnames/* classnames */.d)("my-2", "text-lg", "md:text-2xl", "font-extrabold");
// scroll table
var scrollTableWrapper = (0,tailwindcss_classnames/* classnames */.d)("w-full", "h-px", "table", "whitespace-nowrap");
var scrollContainer = (0,tailwindcss_classnames/* classnames */.d)("ml-4", "md:ml-28", "overflow-scroll", "relative");
var scrollIconContainer = (0,tailwindcss_classnames/* classnames */.d)("flex", "items-center", "mr-auto", "text-nzxt-light-grey-800");

;// CONCATENATED MODULE: ./components/CollectionPage/ComparisonTable/Table/ProductSectionPrice.tsx




// TODO: Remove 'suppressHydrationWarning' from price items
// suppressHydrationWarning is a temporary solution for the server/client mismatch
var ProductSectionPrice_ProductSectionPrice = function(param) {
    var currencyCode = param.currencyCode, product = param.product, optionalClass = param.optionalClass;
    var collectionPagePrice = product.collectionPagePrice;
    var price = usePrice({
        amount: collectionPagePrice,
        currencyCode: currencyCode
    }).price;
    return /*#__PURE__*/ _jsx("p", {
        suppressHydrationWarning: true,
        className: optionalClass || styles.productPrice,
        children: price
    });
};
/* harmony default export */ var Table_ProductSectionPrice = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(ProductSectionPrice_ProductSectionPrice))));

;// CONCATENATED MODULE: ./components/CollectionPage/ComparisonTable/Table/ProductSection.tsx
/* eslint-disable jsx-a11y/control-has-associated-label */ /* eslint-disable jsx-a11y/anchor-is-valid */ 









var ProductSection_ProductSection = function(param) {
    var products = param.products, currencyCode = param.currencyCode, isScroll = param.isScroll;
    var locale = useRouter().locale;
    var region = getRegion(locale);
    var PRODUCTS_LABEL = t("products_label");
    var DETAILS_LABEL = t("details");
    return /*#__PURE__*/ _jsxs("tr", {
        children: [
            /*#__PURE__*/ _jsx("th", {
                className: styles.dataTableHeadingsFaux(isScroll),
                scope: "row",
                children: PRODUCTS_LABEL
            }),
            products.map(function(product) {
                var isRegionallyAvailable = Array.isArray(product === null || product === void 0 ? void 0 : product.availableRegions) ? product === null || product === void 0 ? void 0 : product.availableRegions.some(function(r) {
                    return r.region === region;
                }) : false;
                return /*#__PURE__*/ _jsx("td", {
                    className: styles.productTableData,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.productWrapper,
                        children: [
                            product.collectionPageMainImage && /*#__PURE__*/ _jsx(Image, {
                                className: isScroll && styles.scrollProductSectionImage,
                                data: product.collectionPageMainImage.responsiveImage,
                                width: product.collectionPageMainImage.responsiveImage.width,
                                height: product.collectionPageMainImage.responsiveImage.height
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: styles.headingHeader,
                                children: product.name
                            }, product.id),
                            isRegionallyAvailable && product.variants && product.variants.length > 0 && /*#__PURE__*/ _jsx(ProductSectionPrice, {
                                currencyCode: currencyCode,
                                product: product
                            }),
                            /*#__PURE__*/ _jsx(ButtonLink, {
                                asButton: true,
                                buttonStyle: "secondary",
                                href: "/".concat(ROUTE_PRODUCT, "/").concat(product.slug),
                                internalLink: true,
                                dark: true,
                                children: DETAILS_LABEL
                            })
                        ]
                    })
                }, product.id);
            })
        ]
    });
};
/* harmony default export */ var Table_ProductSection = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(ProductSection_ProductSection))));

;// CONCATENATED MODULE: ./components/CollectionPage/ComparisonTable/Table/CellItem.tsx
/* eslint-disable react/jsx-no-useless-fragment */ 



var getVal = function(feat) {
    switch(feat){
        case feat.length === 0:
            return /*#__PURE__*/ _jsx(IconX, {
                className: styles.svgXStyles
            });
        case feat === false || "No" || 0 || 0 || 0:
            return /*#__PURE__*/ _jsx(IconX, {
                className: styles.svgXStyles
            });
        case feat === true || "Yes" || 0 || 0 || 0 || 0:
            return /*#__PURE__*/ _jsx(IconCheck, {
                className: styles.svgCheckStyles
            });
        case feat.length > 0:
            return feat;
        case feat:
            return feat;
        default:
            return /*#__PURE__*/ _jsx(IconX, {
                className: styles.svgXStyles
            });
    }
};
var CellItem_CellItem = function(param) {
    var label = param.label, value = param.value;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: Array.isArray(value) ? value.map(function(val, index) {
            return(// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ _jsxs("td", {
                className: styles.tdSpacing,
                children: [
                    Array.isArray(val) ? /*#__PURE__*/ _jsx(_Fragment, {
                        children: val.map(function(item, i) {
                            return(// eslint-disable-next-line react/no-array-index-key
                            /*#__PURE__*/ _jsx(Fragment, {
                                children: getVal(item)
                            }, "".concat(item, "-").concat(i)));
                        })
                    }) : /*#__PURE__*/ _jsx(_Fragment, {
                        children: getVal(val)
                    }),
                    /*#__PURE__*/ _jsxs("span", {
                        className: styles.srOnly,
                        children: [
                            label,
                            ": ",
                            val
                        ]
                    })
                ]
            }, "".concat(label, "-").concat(index)));
        }) : /*#__PURE__*/ _jsx("td", {
            className: styles.tdSpacing,
            children: getVal(value)
        })
    });
};
/* harmony default export */ var Table_CellItem = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(CellItem_CellItem))));

;// CONCATENATED MODULE: ./components/CollectionPage/ComparisonTable/Table/DataSection.tsx




var DataSection_DataSection = function(param) {
    var specs = param.specs, isScroll = param.isScroll;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: specs.map(function(param) {
            var label = param.label, value = param.value;
            return /*#__PURE__*/ _jsxs("tr", {
                children: [
                    /*#__PURE__*/ _jsx("th", {
                        className: styles.dataTableHeadings(isScroll),
                        scope: "row",
                        children: label
                    }),
                    value && /*#__PURE__*/ _jsx(CellItem, {
                        label: label,
                        value: value
                    })
                ]
            }, label);
        })
    });
};
/* harmony default export */ var Table_DataSection = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(DataSection_DataSection))));

;// CONCATENATED MODULE: ./components/CollectionPage/ComparisonTable/Table/SingleItemTableSpecs.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 


var SingleItemTableSpecs_SingleItemTableSpecs = function(param) {
    var decoratedSpecs = param.decoratedSpecs;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: decoratedSpecs.map(function(spec) {
            return /*#__PURE__*/ _jsxs("div", {
                className: styles.specsWrapper,
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.specCategory,
                        children: spec.label
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.specValueDetail,
                        children: spec.value
                    })
                ]
            }, spec.label);
        })
    });
};
/* harmony default export */ var Table_SingleItemTableSpecs = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(SingleItemTableSpecs_SingleItemTableSpecs))));

;// CONCATENATED MODULE: ./components/CollectionPage/ComparisonTable/Table/SingleItemTable.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 




var SingleItemTable_SingleItemTable = function(param) {
    var products = param.products;
    return /*#__PURE__*/ _jsx(ContentWrapper, {
        children: products.map(function(product) {
            return /*#__PURE__*/ _jsx("div", {
                className: styles.specsSection,
                children: /*#__PURE__*/ _jsx(SingleItemTableSpecs, {
                    decoratedSpecs: product.decoratedSpecs
                })
            }, product.name);
        })
    });
};
/* harmony default export */ var Table_SingleItemTable = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(SingleItemTable_SingleItemTable))));

;// CONCATENATED MODULE: ./components/CollectionPage/ComparisonTable/Table/ScrollingTable.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 




var ScrollingTable_ScrollingTable = function(param) {
    var products = param.products, currencyCode = param.currencyCode, specData = param.specData;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.scrollContainer,
        children: /*#__PURE__*/ _jsx("table", {
            className: styles.scrollTableWrapper,
            children: /*#__PURE__*/ _jsxs("tbody", {
                className: styles.tableBody,
                children: [
                    /*#__PURE__*/ _jsx(ProductSection, {
                        isScroll: true,
                        products: products,
                        currencyCode: currencyCode
                    }),
                    /*#__PURE__*/ _jsx(DataSection, {
                        isScroll: true,
                        specs: specData
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Table_ScrollingTable = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(ScrollingTable_ScrollingTable))));

;// CONCATENATED MODULE: ./components/CollectionPage/ComparisonTable/Table/LargeTable.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 







var LargeTable_LargeTable = function(param) {
    var products = param.products, currencyCode = param.currencyCode, specData = param.specData;
    var isSmall = useMedia("sm");
    var isMd = useMedia("md");
    var isLarge = !isSmall && !isMd;
    var isLessThanOrEqualToThree = useMemo(function() {
        return products.length <= 3;
    }, [
        products
    ]);
    return isLessThanOrEqualToThree && isLarge ? /*#__PURE__*/ _jsx(ContentWrapper, {
        children: /*#__PURE__*/ _jsx("table", {
            className: styles.largeTable,
            children: /*#__PURE__*/ _jsxs("tbody", {
                className: styles.tableBody,
                children: [
                    /*#__PURE__*/ _jsx(ProductSection, {
                        products: products,
                        currencyCode: currencyCode
                    }),
                    specData.length > 0 && /*#__PURE__*/ _jsx(DataSection, {
                        specs: specData
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ _jsx(ScrollingTable, {
        products: products,
        specData: specData,
        currencyCode: currencyCode
    });
};
/* harmony default export */ var Table_LargeTable = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(LargeTable_LargeTable))));

;// CONCATENATED MODULE: ./components/CollectionPage/ComparisonTable/Table/Table.tsx
/* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable jsx-a11y/anchor-is-valid */ 




var Table_Table = function(param) {
    var products = param.products, currencyCode = param.currencyCode;
    var decoratedProducts = useMemo(function() {
        return products.map(function(product) {
            // eslint-disable-next-line no-param-reassign
            product.decoratedSpecs = product.specs ? Object.keys(product.specs).map(function(spec) {
                return {
                    label: spec,
                    value: product.specs[spec]
                };
            }) : [];
            return product;
        });
    }, [
        products
    ]);
    var specs = useMemo(function() {
        return decoratedProducts.map(function(product) {
            return product.decoratedSpecs.map(function(item) {
                return item;
            });
        });
    }, [
        decoratedProducts
    ]);
    var newSpecs = useMemo(function() {
        return specs.reduce(function(result, current) {
            var _result;
            (_result = result).push.apply(_result, _to_consumable_array(current));
            return result;
        }, []);
    }, [
        specs
    ]);
    var output = useMemo(function() {
        return newSpecs.reduce(function(o, cur) {
            var occurs = o.reduce(function(n, item, i) {
                return item.label === cur.label ? i : n;
            }, -1);
            if (occurs >= 0) {
                // eslint-disable-next-line no-param-reassign
                o[occurs].value = o[occurs].value.concat(cur.value);
            } else {
                var obj = {
                    label: cur.label,
                    value: [
                        cur.value
                    ]
                };
                // eslint-disable-next-line no-param-reassign
                o = o.concat([
                    obj
                ]);
            }
            return o;
        }, []);
    }, [
        newSpecs
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: products && output && /*#__PURE__*/ _jsx(_Fragment, {
            children: products.length > 1 ? /*#__PURE__*/ _jsx(LargeTable, {
                products: products,
                specData: output,
                currencyCode: currencyCode
            }) : /*#__PURE__*/ _jsx(SingleItemTable, {
                products: decoratedProducts
            })
        })
    });
};
/* harmony default export */ var ComparisonTable_Table_Table = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(Table_Table))));

;// CONCATENATED MODULE: ./components/CollectionPage/ComparisonTable/Table/HeadSection.tsx
/* eslint-disable jsx-a11y/control-has-associated-label */ 


var HeadSection = function(param) {
    var products = param.products, isScroll = param.isScroll;
    return /*#__PURE__*/ _jsx("thead", {
        children: /*#__PURE__*/ _jsxs("tr", {
            children: [
                /*#__PURE__*/ _jsx("th", {
                    className: styles.spacingHeader(isScroll),
                    scope: "col"
                }),
                products.map(function(product) {
                    return /*#__PURE__*/ _jsx("th", {
                        className: styles.headingHeader,
                        scope: "col",
                        children: product.name
                    }, product.id);
                })
            ]
        })
    });
};
/* harmony default export */ var Table_HeadSection = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(HeadSection))));

;// CONCATENATED MODULE: ./components/CollectionPage/ComparisonTable/Table/index.ts







;// CONCATENATED MODULE: ./components/CollectionPage/ComparisonTable/ComparisonTable.tsx



var ComparisonTable_ComparisonTable = function(param) {
    var products = param.products, currencyCode = param.currencyCode;
    return /*#__PURE__*/ _jsx(Table, {
        products: products,
        currencyCode: currencyCode
    });
};
/* harmony default export */ var CollectionPage_ComparisonTable_ComparisonTable = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(ComparisonTable_ComparisonTable))));

;// CONCATENATED MODULE: ./components/CollectionPage/ComparisonTable/index.ts

/* harmony default export */ var CollectionPage_ComparisonTable = ((/* unused pure expression or super */ null && (ComparisonTable)));

// EXTERNAL MODULE: ./utils/gtm/index.ts + 3 modules
var gtm = __webpack_require__(96870);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./components/ColorSelectButton/styles.ts


var smallText = (0,tailwindcss_classnames/* classnames */.d)("italic", "text-xs", "text-nzxt-light-grey-300", "md:hidden", "visible");
var smallBehaviour = (0,tailwindcss_classnames/* classnames */.d)("hidden", "md:flex");
var colorSelectButton = (0,tailwindcss_classnames/* classnames */.d)("border-2", "border-transparent", "flex", "flex-row", "items-center", "justify-center", "focus:outline-none", "relative");
var innerColorSelect = (0,tailwindcss_classnames/* classnames */.d)("absolute");
var inActiveBackground = (0,tailwindcss_classnames/* classnames */.d)("border", "border-nzxt-light-grey-600", "border-dashed");
var inActiveBackgroundAvail = (0,tailwindcss_classnames/* classnames */.d)("border-nzxt-light-grey-600", "border");
var activeBackground = (0,tailwindcss_classnames/* classnames */.d)("border-2", "border-nzxt-volt-300");
var marginTop = (0,tailwindcss_classnames/* classnames */.d)("mt-1", "md:mt-0");
var activeButton = function(isActive, isAvailable, isSmall, useMarginTop) {
    var _obj;
    return classnames("flex", "items-center", "justify-center", "mr-1", "last:mr-0", (_obj = {}, _define_property(_obj, inActiveBackground, !isActive && isAvailable), _define_property(_obj, inActiveBackgroundAvail, !isActive && !isAvailable), _define_property(_obj, activeBackground, isActive), _define_property(_obj, smallBehaviour, isSmall), _define_property(_obj, marginTop, useMarginTop), _obj));
};

;// CONCATENATED MODULE: ./components/ColorSelectButton/ColorSelectInner.tsx





var ColorSelectInner_ColorSelectInner = function(param) {
    var variantColor = param.variantColor, _smallSelects = param.smallSelects, smallSelects = _smallSelects === void 0 ? false : _smallSelects;
    var radiusItems = smallSelects ? "22px" : "26px";
    var colorPlacement = smallSelects ? "-11px" : "-13px";
    var moreThanOneColorPos0 = {
        borderTopLeftRadius: radiusItems,
        borderBottomLeftRadius: radiusItems,
        left: colorPlacement
    };
    var moreThanOneColorPos1 = {
        borderTopRightRadius: radiusItems,
        borderBottomRightRadius: radiusItems,
        right: colorPlacement
    };
    var RADIUS_MAP = {
        0: moreThanOneColorPos0,
        1: moreThanOneColorPos1
    };
    var oneColor = {
        borderRadius: "50%",
        left: colorPlacement
    };
    var css = smallSelects ? extraStyles.swatchSmall : extraStyles.swatchDefault;
    return /*#__PURE__*/ _jsx("div", {
        className: css,
        style: {
            borderRadius: "50%",
            backgroundColor: "rgba(255,255,255, 0)",
            zIndex: 2
        },
        children: variantColor.map(function(color, i) {
            var borderStyles = variantColor.length > 1 ? RADIUS_MAP[i] : oneColor;
            return /*#__PURE__*/ _jsx("span", {
                className: styles.innerColorSelect,
                style: _object_spread({
                    backgroundColor: "".concat(color.color.hex),
                    width: variantColor.length > 1 ? "calc(".concat(radiusItems, " / 2)") : radiusItems,
                    height: radiusItems,
                    top: colorPlacement
                }, borderStyles)
            }, "".concat(color.name, "-").concat(color.color.hex));
        })
    });
};
/* harmony default export */ var ColorSelectButton_ColorSelectInner = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(ColorSelectInner_ColorSelectInner))));

;// CONCATENATED MODULE: ./components/ColorSelectButton/ColorSelectButton.tsx
/* eslint-disable no-nested-ternary */ /* eslint-disable jsx-a11y/anchor-is-valid */ 









var ColorSelectButton_ColorSelectButton = function(param) {
    var variants = param.variants, setVariant = param.setVariant, selectedVariant = param.selectedVariant, _smallSelects = param.smallSelects, smallSelects = _smallSelects === void 0 ? false : _smallSelects, _isRegionallyAvailable = param.isRegionallyAvailable, isRegionallyAvailable = _isRegionallyAvailable === void 0 ? true : _isRegionallyAvailable, productName = param.productName, _isFaux = param.isFaux, isFaux = _isFaux === void 0 ? false : _isFaux, slug = param.slug, handleClick = param.handleClick, _useMarginTop = param.useMarginTop, useMarginTop = _useMarginTop === void 0 ? false : _useMarginTop, customSelect = param.customSelect;
    var handleSelect = function(index) {
        setVariant(variants[index]);
    };
    var CHOOSE_LABEL = t("choose_label");
    var selectedVariantIndex = useMemo(function() {
        return variants.indexOf(selectedVariant);
    }, [
        variants,
        selectedVariant
    ]);
    var sizeOuter = smallSelects ? "28px" : "32px";
    var sizeInner = smallSelects ? "20px" : "26px";
    var startDate = new Date().getTime();
    var variantsWithState = variants.map(function(v, i) {
        return _object_spread_props(_object_spread({}, v), {
            isExpired: (v === null || v === void 0 ? void 0 : v.showCountdownTimer) ? startDate > new Date(v === null || v === void 0 ? void 0 : v.countdownEndDate).getTime() : false,
            isActiveVar: i === selectedVariantIndex
        });
    });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: variantsWithState.map(function(variant, i) {
            return variant.color && variant.color.length > 0 ? isFaux ? /*#__PURE__*/ _jsx(Link, {
                passHref: true,
                href: {
                    pathname: "/".concat(ROUTE_PRODUCT, "/").concat(slug),
                    query: {
                        variant: i
                    }
                },
                children: /*#__PURE__*/ _jsx("a", {
                    role: "option",
                    "aria-selected": Boolean(i === selectedVariantIndex),
                    "aria-label": "".concat(CHOOSE_LABEL, " ").concat(productName, " ").concat(variant.color.map(function(color) {
                        return color.name;
                    }).join(" ")),
                    className: styles.activeButton(i === selectedVariantIndex, (variant === null || variant === void 0 ? void 0 : variant.isExpired) || !isRegionallyAvailable || variant.isOutOfStock, smallSelects, useMarginTop),
                    style: {
                        borderRadius: "50%",
                        width: sizeOuter,
                        height: sizeOuter
                    },
                    onClick: handleClick ? function() {
                        return handleClick();
                    } : null,
                    onKeyDown: handleClick ? function() {
                        return handleClick();
                    } : null,
                    tabIndex: 0,
                    children: /*#__PURE__*/ _jsx("span", {
                        className: styles.colorSelectButton,
                        style: {
                            borderRadius: "50%",
                            width: sizeInner,
                            height: sizeInner
                        },
                        children: /*#__PURE__*/ _jsx(ColorSelectInner, {
                            smallSelects: smallSelects,
                            variantColor: variant.color
                        })
                    })
                }, "".concat(variant.id, "-").concat(variant.color.map(function(color) {
                    return color.name;
                }).join("/")))
            }, "/".concat(ROUTE_PRODUCT, "/").concat(slug, "/").concat(variant.id)) : /*#__PURE__*/ _jsx("button", {
                "aria-pressed": Boolean(i === selectedVariantIndex),
                "aria-label": "".concat(CHOOSE_LABEL, " ").concat(productName, " ").concat(variant.color.map(function(color) {
                    return color.name;
                }).join(" ")),
                id: "variant-select-button-".concat(slugify(productName || "empty"), "-").concat(slugify(variant.color.map(function(color) {
                    return color.name;
                }).join("-"))),
                onClick: customSelect ? function() {
                    return customSelect(i);
                } : function() {
                    return handleSelect(i);
                },
                className: styles.activeButton(i === selectedVariantIndex, (variant === null || variant === void 0 ? void 0 : variant.isExpired) || !isRegionallyAvailable || variant.isOutOfStock, smallSelects, useMarginTop),
                style: {
                    borderRadius: "50%",
                    width: sizeOuter,
                    height: sizeOuter
                },
                type: "button",
                children: /*#__PURE__*/ _jsx("span", {
                    className: styles.colorSelectButton,
                    style: {
                        borderRadius: "50%",
                        width: sizeInner,
                        height: sizeInner
                    },
                    children: /*#__PURE__*/ _jsx(ColorSelectInner, {
                        smallSelects: smallSelects,
                        variantColor: variant.color
                    })
                })
            }, "".concat(variant.id, "-").concat(variant.color.map(function(color) {
                return color.name;
            }).join("/"))) : null;
        })
    });
};
/* harmony default export */ var components_ColorSelectButton_ColorSelectButton = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(ColorSelectButton_ColorSelectButton))));

;// CONCATENATED MODULE: ./components/ColorSelectButton/index.ts


;// CONCATENATED MODULE: ./components/CardComponents/CardColorVariants/styles.ts

var optionsGrid = (0,tailwindcss_classnames/* classnames */.d)("space-y-2", "flex");
var copyGrid = (0,tailwindcss_classnames/* classnames */.d)(optionsGrid, "items-end", "text-nzxt-light-grey-800");
var colorSelectItem = (0,tailwindcss_classnames/* classnames */.d)("flex", "ml-auto", "items-start");
var lightGreyCopy = (0,tailwindcss_classnames/* classnames */.d)("ml-auto", "flex", "text-xs", "my-auto", "text-nzxt-light-grey-600", "underline", "mr-2");

;// CONCATENATED MODULE: ./components/CardComponents/CardColorVariants/CardColorVariants.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 








var CardColorVariants_CardColorVariants = function(param) {
    var isRegionallyAvailable = param.isRegionallyAvailable, variants = param.variants, selectedVariant = param.selectedVariant, setSelectedVariant = param.setSelectedVariant, productName = param.productName, _isFaux = param.isFaux, isFaux = _isFaux === void 0 ? false : _isFaux, slug = param.slug, _isSmall = param.isSmall, isSmall = _isSmall === void 0 ? false : _isSmall, handleClick = param.handleClick;
    var isMoreThanThree = Array.isArray(variants) && variants.length > 3;
    var colorsSlicedVariants = Array.isArray(variants) && (variants === null || variants === void 0 ? void 0 : variants.slice(0, 3));
    var variantOptions = isMoreThanThree ? colorsSlicedVariants : variants;
    var remainingVariantAmount = isMoreThanThree ? Array.isArray(variants) && variants.length - 3 : 0;
    var COLOR_OPTIONS_LABEL = t("color_options");
    return /*#__PURE__*/ _jsx("div", {
        className: styles.optionsGrid,
        children: Array.isArray(selectedVariant.color) && selectedVariant.color.length >= 1 && /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
            className: styles.colorSelectItem
        }, isFaux && {
            role: "listbox",
            "aria-label": COLOR_OPTIONS_LABEL
        }), {
            children: [
                /*#__PURE__*/ _jsx(ColorSelectButton, {
                    setVariant: setSelectedVariant,
                    variants: variantOptions,
                    selectedVariant: selectedVariant,
                    isRegionallyAvailable: isRegionallyAvailable,
                    productName: productName || "empty",
                    slug: slug,
                    isFaux: isFaux,
                    smallSelects: isSmall,
                    handleClick: handleClick
                }),
                isMoreThanThree && remainingVariantAmount > 0 && /*#__PURE__*/ _jsx(Link, {
                    href: "/".concat(ROUTE_PRODUCT, "/").concat(slug),
                    passHref: true,
                    children: /*#__PURE__*/ _jsxs("a", {
                        className: styles.lightGreyCopy,
                        role: "link",
                        tabIndex: 0,
                        onClick: handleClick ? function() {
                            return handleClick();
                        } : null,
                        onKeyDown: handleClick ? function() {
                            return handleClick();
                        } : null,
                        children: [
                            "+ ",
                            remainingVariantAmount
                        ]
                    })
                })
            ]
        }))
    });
};
/* harmony default export */ var CardComponents_CardColorVariants_CardColorVariants = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(CardColorVariants_CardColorVariants))));

;// CONCATENATED MODULE: ./components/CardComponents/CardColorVariants/index.ts


;// CONCATENATED MODULE: ./components/CardComponents/CardPrice/styles.ts


var priceDiscounted = (0,tailwindcss_classnames/* classnames */.d)("line-through", "mr-2", "text-nzxt-light-grey-600");
var styles_smallText = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "md:text-sm");
var priceContainer = (0,tailwindcss_classnames/* classnames */.d)("flex", "flex-wrap", "w-full");
var discountedPricedText = function(isSmall) {
    return classnames("text-nzxt-light-grey-800", _define_property({}, styles_smallText, isSmall));
};
var isOnSale = function(salePrice, isSmall) {
    var _obj;
    return classnames((_obj = {}, _define_property(_obj, priceDiscounted, salePrice), _define_property(_obj, styles_smallText, isSmall), _obj));
};
var noOpacity = (0,tailwindcss_classnames/* classnames */.d)("opacity-0");
var fullOpacity = (0,tailwindcss_classnames/* classnames */.d)("opacity-100");
var smallSpan = (0,tailwindcss_classnames/* classnames */.d)("col-span-2", "md:col-span-1");
var isVisible = function(hasVisibility, isSmall) {
    var _obj;
    return classnames((_obj = {}, _define_property(_obj, smallSpan, isSmall), _define_property(_obj, noOpacity, !hasVisibility), _define_property(_obj, fullOpacity, hasVisibility), _obj));
};

;// CONCATENATED MODULE: ./components/CardComponents/CardPrice/ProductPrice.tsx
/* eslint-disable camelcase */ 



// TODO: Remove 'suppressHydrationWarning' from price items
// suppressHydrationWarning is a temporary solution for the server/client mismatch
var ProductPrice_ProductPrice = function(param) {
    var priceBase = param.priceBase, priceDiscount = param.priceDiscount, currencyCode = param.currencyCode, isOnSale = param.isOnSale, slug = param.slug, _isSmall = param.isSmall, isSmall = _isSmall === void 0 ? false : _isSmall;
    var ref = usePrice({
        amount: priceDiscount,
        currencyCode: currencyCode
    }), discoPrice = ref.price;
    var price = usePrice({
        amount: priceBase,
        currencyCode: currencyCode
    }).price;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.priceContainer,
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: styles.isOnSale(isOnSale, isSmall),
                "data-test-id": "".concat(slug, "-price"),
                suppressHydrationWarning: true,
                children: price
            }),
            isOnSale && /*#__PURE__*/ _jsx("p", {
                suppressHydrationWarning: true,
                className: styles.discountedPricedText(isSmall),
                children: discoPrice
            })
        ]
    });
};
/* harmony default export */ var CardPrice_ProductPrice = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(ProductPrice_ProductPrice))));

;// CONCATENATED MODULE: ./components/CardComponents/CardPrice/CardPrice.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 



var CardPrice_ProductCard = function(param) {
    var currencyCode = param.currencyCode, slug = param.slug, selectedVariant = param.selectedVariant, isRegionallyAvailable = param.isRegionallyAvailable, _isSmall = param.isSmall, isSmall = _isSmall === void 0 ? false : _isSmall;
    /*#__PURE__*/ return _jsx("div", {
        className: styles.isVisible(Boolean(isRegionallyAvailable && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.price) > 0), isSmall),
        children: /*#__PURE__*/ _jsx(ProductPrice, {
            slug: slug,
            priceBase: selectedVariant.price,
            priceDiscount: selectedVariant.discounted_price,
            isOnSale: selectedVariant.isOnSale,
            currencyCode: currencyCode,
            isSmall: isSmall
        })
    });
};
/* harmony default export */ var CardPrice_CardPrice = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(CardPrice_ProductCard))));

;// CONCATENATED MODULE: ./components/CardComponents/CardPrice/index.ts


;// CONCATENATED MODULE: ./components/CardComponents/CardWrapper/styles.ts

var cardWrapper = (0,tailwindcss_classnames/* classnames */.d)("flex", "flex-col", "h-full", "max-w-md", "relative");
/* harmony default export */ var CardWrapper_styles = ((/* unused pure expression or super */ null && (cardWrapper)));

;// CONCATENATED MODULE: ./components/CardComponents/CardWrapper/CardWrapper.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 


var CardWrapper_CardWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.cardWrapper,
        children: children
    });
};
/* harmony default export */ var CardComponents_CardWrapper_CardWrapper = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(CardWrapper_CardWrapper))));

;// CONCATENATED MODULE: ./components/CardComponents/CardWrapper/index.ts


;// CONCATENATED MODULE: ./components/CardComponents/CardExtendedDetails/styles.ts


var defaultHeading = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "font-bold");
var hasNoDetails = (0,tailwindcss_classnames/* classnames */.d)("text-base");
var CardExtendedDetails_styles_smallText = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "md:text-sm");
var styles_heading = function(hasDetail, isSmall) {
    var _obj;
    return classnames((_obj = {}, _define_property(_obj, defaultHeading, hasDetail), _define_property(_obj, hasNoDetails, !hasDetail && !isSmall), _define_property(_obj, CardExtendedDetails_styles_smallText, !hasDetail && isSmall), _obj));
};
var fake = (0,tailwindcss_classnames/* classnames */.d)("flex", "space-x-2");
var styles_subheading = function(isFauxPrice) {
    return classnames("text-xs", "text-nzxt-light-grey-700", _define_property({}, fake, isFauxPrice));
};
var defaultBorder = (0,tailwindcss_classnames/* classnames */.d)("border-t", "pt-4", "mb-4", "flex-1");
var container = function(isFauxPrice) {
    return classnames(_define_property({}, defaultBorder, !isFauxPrice), "flex-grow");
};

;// CONCATENATED MODULE: ./components/CardComponents/CardExtendedDetails/CardExtendedDetails.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 




var CardExtendedDetails_CardExtendedDetails = function(param) {
    var extendedHeading = param.extendedHeading, extendedDetails = param.extendedDetails, _isFauxPrice = param.isFauxPrice, isFauxPrice = _isFauxPrice === void 0 ? false : _isFauxPrice, _isSmall = param.isSmall, isSmall = _isSmall === void 0 ? false : _isSmall;
    var hasDetail = extendedDetails && Array.isArray(extendedDetails) && (extendedDetails === null || extendedDetails === void 0 ? void 0 : extendedDetails.length) > 0;
    var minHeightStyles = !isFauxPrice ? {
        minHeight: "81px"
    } : {};
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container(isFauxPrice),
        style: _object_spread_props(_object_spread({}, minHeightStyles), {
            flexBasis: "max-content"
        }),
        children: [
            extendedHeading && /*#__PURE__*/ _jsx("p", {
                className: styles.heading(hasDetail, isSmall),
                children: extendedHeading
            }),
            hasDetail && (extendedDetails === null || extendedDetails === void 0 ? void 0 : extendedDetails.map(function(detail) {
                return /*#__PURE__*/ _jsx("p", {
                    className: styles.subheading(isFauxPrice),
                    children: detail
                }, detail);
            }))
        ]
    });
};
/* harmony default export */ var CardComponents_CardExtendedDetails_CardExtendedDetails = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(CardExtendedDetails_CardExtendedDetails))));

;// CONCATENATED MODULE: ./components/CardComponents/CardExtendedDetails/index.ts


;// CONCATENATED MODULE: ./components/CardComponents/CardContentWrapper/styles.ts

var cardContentWrapper = (0,tailwindcss_classnames/* classnames */.d)("flex", "flex-col", "w-full");
/* harmony default export */ var CardContentWrapper_styles = ((/* unused pure expression or super */ null && (cardContentWrapper)));

;// CONCATENATED MODULE: ./components/CardComponents/CardContentWrapper/CardContentWrapper.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 


var CardContentWrapper_CardContentWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.cardContentWrapper,
        children: children
    });
};
/* harmony default export */ var CardComponents_CardContentWrapper_CardContentWrapper = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(CardContentWrapper_CardContentWrapper))));

;// CONCATENATED MODULE: ./components/CardComponents/CardContentWrapper/index.ts


// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./stores/use-ui-store/index.ts + 2 modules
var use_ui_store = __webpack_require__(86649);
// EXTERNAL MODULE: ./framework/cart/use-add-item.tsx + 1 modules
var use_add_item = __webpack_require__(2165);
;// CONCATENATED MODULE: ./components/CardComponents/CardImage/styles.ts


var styles_image = (0,tailwindcss_classnames/* classnames */.d)("z-0", "max-w-lg");
var imageWrapper = (0,tailwindcss_classnames/* classnames */.d)("relative", "w-full", "p-4", "xl:p-10", "bg-nzxt-light-grey-50");
var bottomRight = (0,tailwindcss_classnames/* classnames */.d)("bottom-0", "left-0");
var topLeft = (0,tailwindcss_classnames/* classnames */.d)("top-10", "left-10", "h-full");
var textWrapper = function(isTopLeft) {
    var _obj;
    return classnames("absolute", (_obj = {}, _define_property(_obj, topLeft, isTopLeft), _define_property(_obj, bottomRight, !isTopLeft), _obj));
};
var quickBuyButton = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-volt-400", "border", "rounded-full", "p-2.5", "scale-100", "transform", "duration-200", "hover:scale-110");
var shoppingCart = (0,tailwindcss_classnames/* classnames */.d)("text-white", "fill-current", "h-5", "w-5");

;// CONCATENATED MODULE: ./components/CardComponents/CardImage/QuickBuy.tsx












var QuickBuy_QuickBuy = function(param) {
    var selectedVariant = param.selectedVariant, currencyCode = param.currencyCode, name = param.name;
    var openCart = useUiStore(getOpenCart);
    var asPath = useRouter().asPath;
    var ref = useState(false), loading = ref[0], setLoading = ref[1];
    var quantity = 1;
    var addItem = useAddItem();
    var addToCart = function() {
        var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee() {
            var // eslint-disable-next-line security/detect-non-literal-fs-filename
            ref, ref1;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        try {
                            if (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.shopify_variants_id) {
                                ;
                                window === null || window === void 0 ? void 0 : (ref = window.Extend) === null || ref === void 0 ? void 0 : (ref1 = ref.modal) === null || ref1 === void 0 ? void 0 : ref1.open({
                                    referenceId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.shopify_variants_id,
                                    onClose: function() {
                                        var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee(plan, product) {
                                            var ref;
                                            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                                while(1)switch(_ctx.prev = _ctx.next){
                                                    case 0:
                                                        if (!(plan && product && (window === null || window === void 0 ? void 0 : window.ExtendShopify))) {
                                                            _ctx.next = 4;
                                                            break;
                                                        }
                                                        {
                                                            ;
                                                            (ref = window.ExtendShopify) === null || ref === void 0 ? void 0 : ref.getPlanVariant({
                                                                referenceId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.shopify_variants_id,
                                                                termLength: plan === null || plan === void 0 ? void 0 : plan.term
                                                            }, function() {
                                                                var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee(err, planVariant) {
                                                                    var items;
                                                                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                                            case 0:
                                                                                if (!err) {
                                                                                    _ctx.next = 2;
                                                                                    break;
                                                                                }
                                                                                return _ctx.abrupt("return", err);
                                                                            case 2:
                                                                                items = [
                                                                                    {
                                                                                        shopify_variants_id: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.shopify_variants_id,
                                                                                        quantity: quantity
                                                                                    },
                                                                                    {
                                                                                        shopify_variants_id: planVariant.variantId,
                                                                                        quantity: quantity,
                                                                                        attributes: [
                                                                                            {
                                                                                                key: "Extend.IsExtendWarranty",
                                                                                                value: "true"
                                                                                            }, 
                                                                                        ]
                                                                                    }, 
                                                                                ].filter(Boolean);
                                                                                _ctx.next = 5;
                                                                                return addItem(items).then(function() {
                                                                                    openCart();
                                                                                    setLoading(false);
                                                                                });
                                                                            case 5:
                                                                                return _ctx.abrupt("return", planVariant);
                                                                            case 6:
                                                                            case "end":
                                                                                return _ctx.stop();
                                                                        }
                                                                    }, _callee);
                                                                }));
                                                                return function(err, planVariant) {
                                                                    return _ref.apply(this, arguments);
                                                                };
                                                            }());
                                                        }
                                                        _ctx.next = 6;
                                                        break;
                                                    case 4:
                                                        _ctx.next = 6;
                                                        return addItem({
                                                            shopify_variants_id: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.shopify_variants_id,
                                                            quantity: quantity
                                                        }).then(function() {
                                                            openCart();
                                                            setLoading(false);
                                                        });
                                                    case 6:
                                                    case "end":
                                                        return _ctx.stop();
                                                }
                                            }, _callee);
                                        }));
                                        return function(plan, product) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()
                                });
                            }
                            GTM.dataLayer({
                                dataLayer: {
                                    event: "warrantyModal",
                                    triggerSource: "Quick cart action"
                                }
                            });
                        } catch (err) {
                            setLoading(false);
                        }
                        // track add to cart for GA enhanced ecommerce
                        GTM.dataLayer({
                            dataLayer: {
                                event: "addToCartQuickBuy",
                                ecommerce: {
                                    currencyCode: currencyCode,
                                    add: {
                                        products: [
                                            {
                                                name: name,
                                                id: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
                                                price: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.price.toString(),
                                                brand: "NZXT",
                                                variant: Array.isArray(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.color) ? selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.color.map(function(color) {
                                                    return color.name;
                                                }).join("/") : null,
                                                quantity: quantity,
                                                productTitle: name,
                                                pageName: asPath
                                            }, 
                                        ]
                                    }
                                }
                            }
                        });
                        // track add to cart via facebook pixel
                        if (window.fbq) {
                            window.fbq("track", "AddToCartQuickBuy", {
                                content_name: name,
                                content_ids: [
                                    selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id
                                ],
                                content_type: "product",
                                value: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.price,
                                currency: currencyCode
                            });
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function addToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx("button", {
        onClick: addToCart,
        type: "button",
        disabled: loading,
        className: styles.quickBuyButton,
        "aria-label": "".concat(t("add_to_cart"), " ").concat(name, " ").concat(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.color.map(function(color) {
            return color.name;
        }).join("-"), " "),
        id: "".concat(slugify(name), "-quick-buy-button"),
        children: /*#__PURE__*/ _jsx(IconShoppingCart, {
            className: styles.shoppingCart
        })
    });
};
/* harmony default export */ var CardImage_QuickBuy = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(QuickBuy_QuickBuy))));

;// CONCATENATED MODULE: ./utils/get-stock-notification.ts

function get_stock_notification_getStockNotification(language, stock) {
    switch(language === null || language === void 0 ? void 0 : language.toLowerCase()){
        // english
        case DEFAULT_LANGUAGE_CODE === null || DEFAULT_LANGUAGE_CODE === void 0 ? void 0 : DEFAULT_LANGUAGE_CODE.toLowerCase():
            return "Only ".concat(stock, " left!");
        // spanish
        case SPAIN_COUNTRY_CODE === null || SPAIN_COUNTRY_CODE === void 0 ? void 0 : SPAIN_COUNTRY_CODE.toLowerCase():
            return "\xa1S\xf3lo quedan ".concat(stock, "!");
        // italian
        case ITALY_COUNTRY_CODE === null || ITALY_COUNTRY_CODE === void 0 ? void 0 : ITALY_COUNTRY_CODE.toLowerCase():
            return "Ne rimangono solo ".concat(stock, "!");
        // dutch
        case NETHERLANDS_COUNTRY_CODE === null || NETHERLANDS_COUNTRY_CODE === void 0 ? void 0 : NETHERLANDS_COUNTRY_CODE.toLowerCase():
            return "Nog maar ".concat(stock, " over!");
        // french
        case FRANCE_COUNTRY_CODE === null || FRANCE_COUNTRY_CODE === void 0 ? void 0 : FRANCE_COUNTRY_CODE.toLowerCase():
            return "Il n'en reste que ".concat(stock, " !");
        // german
        case GERMANY_COUNTRY_CODE === null || GERMANY_COUNTRY_CODE === void 0 ? void 0 : GERMANY_COUNTRY_CODE.toLocaleLowerCase():
            return "Nur noch ".concat(stock, " \xfcbrig!");
        // japanese
        case JAPAN_COUNTRY_CODE === null || JAPAN_COUNTRY_CODE === void 0 ? void 0 : JAPAN_COUNTRY_CODE.toLowerCase():
            return "Only ".concat(stock, " left!");
        default:
            return "";
    }
};

;// CONCATENATED MODULE: ./components/CardComponents/StockNotification/styles.ts


// stock
var inventoryCount = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-green-400", "font-semibold", "text-xs");
var topMargin = (0,tailwindcss_classnames/* classnames */.d)("mt-3");
var countContainer = function(spaceTop) {
    return classnames("flex", "col-span-2", "w-full", "mb-1", _define_property({}, topMargin, spaceTop));
};

;// CONCATENATED MODULE: ./components/CardComponents/StockNotification/StockNotification.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 






var StockNotification_StockNotification = function(param) {
    var inventoryData = param.inventoryData, _spaceTop = param.spaceTop, spaceTop = _spaceTop === void 0 ? false : _spaceTop;
    // set filter for language
    var router = useRouter();
    var locale = router.locale, defaultLocale = router.defaultLocale;
    var parsedLocale = parseLocale(defaultLocale, locale);
    var lang = parsedLocale[0] || DEFAULT_LANGUAGE_CODE;
    // Show if equal to or less than 15
    // Does not show if greater than 15
    // Does not show if stock is 0
    var showStockDecrement = (inventoryData === null || inventoryData === void 0 ? void 0 : inventoryData.stock) <= 15 && (inventoryData === null || inventoryData === void 0 ? void 0 : inventoryData.stock) > 0;
    return showStockDecrement && (inventoryData === null || inventoryData === void 0 ? void 0 : inventoryData.showInventory) ? /*#__PURE__*/ _jsx("div", {
        className: styles.countContainer(spaceTop),
        children: /*#__PURE__*/ _jsx("p", {
            className: styles.inventoryCount,
            children: getStockNotification(lang, (inventoryData === null || inventoryData === void 0 ? void 0 : inventoryData.stock) || 0)
        })
    }) : null;
};
/* harmony default export */ var CardComponents_StockNotification_StockNotification = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(StockNotification_StockNotification))));

;// CONCATENATED MODULE: ./components/CardComponents/StockNotification/index.ts


;// CONCATENATED MODULE: ./components/CardComponents/CardHeading/styles.ts


var smallHeading = (0,tailwindcss_classnames/* classnames */.d)("text-sm", "md:text-lg");
var styles_defaultHeading = (0,tailwindcss_classnames/* classnames */.d)("text-lg");
var CardHeading_styles_heading = function(isSmall) {
    var _obj;
    return classnames("font-bold", "text-nzxt-light-grey-800", (_obj = {}, _define_property(_obj, smallHeading, isSmall), _define_property(_obj, styles_defaultHeading, !isSmall), _obj));
};
var shortDescription = (0,tailwindcss_classnames/* classnames */.d)("flex", "col-span-2", "w-full");
var descriptionColor = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-light-grey-600", "text-xs");
var styles_container = (0,tailwindcss_classnames/* classnames */.d)("mb-4");

;// CONCATENATED MODULE: ./components/CardComponents/CardHeading/CardHeading.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 





var CardHeading_CardHeading = function(param) {
    var name = param.name, slug = param.slug, shortDescription = param.shortDescription, isExtended = param.isExtended, _isSmall = param.isSmall, isSmall = _isSmall === void 0 ? false : _isSmall, inventoryData = param.inventoryData;
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, isExtended ? {
        className: styles.container
    } : {}), {
        style: {
            flex: "0.5 0 0%",
            flexBasis: "max-content"
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: name && /*#__PURE__*/ _jsx("p", {
                    className: styles.heading(isSmall),
                    "data-test-id": "".concat(slug, "-heading"),
                    children: name
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.shortDescription,
                children: /*#__PURE__*/ _jsx("p", {
                    className: styles.descriptionColor,
                    children: shortDescription
                })
            }),
            /*#__PURE__*/ _jsx(StockNotification, {
                spaceTop: true,
                inventoryData: inventoryData
            })
        ]
    }));
};
/* harmony default export */ var CardComponents_CardHeading_CardHeading = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(CardHeading_CardHeading))));

;// CONCATENATED MODULE: ./components/CardComponents/CardHeading/index.ts


// EXTERNAL MODULE: ./components/IconDynamic/index.ts + 1 modules
var components_IconDynamic = __webpack_require__(55720);
;// CONCATENATED MODULE: ./components/CardComponents/CardService/styles.ts

var textBase = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "flex", "items-center", "text-nzxt-green-400", "my-1");
var icon = (0,tailwindcss_classnames/* classnames */.d)("hidden", "md:block", "w-4", "h-4", "mr-1");

;// CONCATENATED MODULE: ./components/CardComponents/CardService/CardService.tsx
/* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable jsx-a11y/anchor-is-valid */ 





var CardService_CardService = function(param) {
    var service = param.service;
    var isSm = useMedia("sm");
    var LABEL_PROMO = t("label_promotion");
    var LABEL_PROMOS = t("label_promotions");
    var hasService = Array.isArray(service) ? (service === null || service === void 0 ? void 0 : service.length) > 0 : Boolean(service === null || service === void 0 ? void 0 : service.copy);
    return hasService ? /*#__PURE__*/ _jsx(_Fragment, {
        children: Array.isArray(service) && (service === null || service === void 0 ? void 0 : service.length) > 0 ? /*#__PURE__*/ _jsxs("div", {
            className: styles.textBase,
            children: [
                !isSm && /*#__PURE__*/ _jsx(IconSpecialPromotions, {
                    className: styles.icon
                }),
                (service === null || service === void 0 ? void 0 : service.length) > 1 && (service === null || service === void 0 ? void 0 : service.length),
                " ",
                (service === null || service === void 0 ? void 0 : service.length) > 1 ? LABEL_PROMOS : LABEL_PROMO
            ]
        }) : /*#__PURE__*/ _jsxs("div", {
            className: styles.textBase,
            children: [
                !isSm && !Array.isArray(service) && (service === null || service === void 0 ? void 0 : service.iconName) && /*#__PURE__*/ _jsx(IconDynamic, {
                    iconName: service.iconName,
                    className: styles.icon
                }),
                !Array.isArray(service) && (service === null || service === void 0 ? void 0 : service.copy)
            ]
        })
    }) : null;
};
/* harmony default export */ var CardComponents_CardService_CardService = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(CardService_CardService))));

;// CONCATENATED MODULE: ./components/CardComponents/CardService/index.ts


;// CONCATENATED MODULE: ./components/PDP/AvailabilityMessage/styles.ts

// eslint-disable-next-line import/prefer-default-export
var base = (0,tailwindcss_classnames/* classnames */.d)("font-bold", "text-xs", "py-1", "px-2", "rounded", "inline-block");
var outOfStock = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-light-grey-800", "border", "border-nzxt-light-grey-800");
var lowStock = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-yellow-200", "text-nzxt-brown-500");
var onSale = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-green-400", "text-white");
var isPromo = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-green-200", "text-nzxt-green-500");
var invalid = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-red-400", "border", "border-nzxt-red-400");
var newItem = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-blue-400", "text-white");
var comingSoon = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-blue-400", "border", "border-nzxt-blue-400");

;// CONCATENATED MODULE: ./components/PDP/AvailabilityMessage/AvailabilityMessage.tsx





var getData = function(param) {
    var isValid = param.isValid, isLowStock = param.isLowStock, isOutOfStock = param.isOutOfStock, isOnSale = param.isOnSale, isComingSoon = param.isComingSoon, isNewItem = param.isNewItem, isRegionallyAvailable = param.isRegionallyAvailable, showSaleTag = param.showSaleTag, isPromo = param.isPromo, showPercentOff = param.showPercentOff, percentOff = param.percentOff, isExpired = param.isExpired;
    if (!isRegionallyAvailable) {
        return {
            message: "message_unavailable",
            style: styles.outOfStock
        };
    }
    if (isComingSoon) {
        return {
            message: "message_coming_soon",
            style: styles.comingSoon
        };
    }
    if (isOutOfStock || isExpired) {
        return {
            message: "message_out_of_stock",
            style: styles.outOfStock
        };
    }
    if (showPercentOff && percentOff) {
        return {
            message: "discount_label",
            style: styles.onSale
        };
    }
    if (isOnSale || showSaleTag) {
        return {
            message: "message_on_sale",
            style: styles.onSale
        };
    }
    if (isPromo) {
        return {
            message: "message_promotion",
            style: styles.isPromo
        };
    }
    if (isLowStock) {
        return {
            message: "message_low_stock",
            style: styles.lowStock
        };
    }
    if (isNewItem) {
        return {
            message: "message_new_item",
            style: styles.newItem
        };
    }
    if (!isValid) {
        return {
            message: "message_invalid",
            style: styles.invalid
        };
    }
    return null;
};
var AvailabilityMessage_AvailabilityMessage = function(param) {
    var variant = param.variant, isExpired = param.isExpired, isRegionallyAvailable = param.isRegionallyAvailable;
    var isValid = variant.isValid, isLowStock = variant.isLowStock, isOutOfStock = variant.isOutOfStock, isOnSale = variant.isOnSale, isComingSoon = variant.isComingSoon, isNewItem = variant.isNewItem, showSaleTag = variant.showSaleTag, isPromo = variant.isPromo, showPercentOff = variant.showPercentOff, percentOff = variant.percentOff;
    var currentData = useMemo(function() {
        return getData({
            isValid: isValid,
            isLowStock: isLowStock,
            isOutOfStock: isOutOfStock,
            isOnSale: isOnSale,
            isComingSoon: isComingSoon,
            isNewItem: isNewItem,
            isRegionallyAvailable: isRegionallyAvailable,
            showSaleTag: showSaleTag,
            isPromo: isPromo,
            showPercentOff: showPercentOff,
            percentOff: percentOff,
            isExpired: isExpired
        });
    }, [
        isValid,
        isLowStock,
        isOutOfStock,
        isOnSale,
        isComingSoon,
        isNewItem,
        isRegionallyAvailable,
        showSaleTag,
        isPromo,
        showPercentOff,
        percentOff,
        isExpired, 
    ]);
    var composedClassName = useMemo(function() {
        return cn(styles.base, currentData && currentData.style);
    }, [
        currentData
    ]);
    var ref;
    var id = (ref = currentData === null || currentData === void 0 ? void 0 : currentData.message) !== null && ref !== void 0 ? ref : "ok";
    var MESSAGE = t(id);
    var showOffLabel = isRegionallyAvailable && !isComingSoon && !isOutOfStock && !isExpired && showPercentOff && percentOff;
    return currentData ? /*#__PURE__*/ _jsx("p", {
        className: composedClassName,
        children: showOffLabel ? "".concat(percentOff, "% ").concat(MESSAGE) : MESSAGE
    }) : null;
};
/* harmony default export */ var PDP_AvailabilityMessage_AvailabilityMessage = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(AvailabilityMessage_AvailabilityMessage))));

;// CONCATENATED MODULE: ./components/PDP/AvailabilityMessage/index.ts

/* harmony default export */ var PDP_AvailabilityMessage = ((/* unused pure expression or super */ null && (AvailabilityMessage)));

;// CONCATENATED MODULE: ./components/CardComponents/CardImage/CardImage.tsx
/* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable jsx-a11y/anchor-is-valid */ 




var CardImage_CardImage = function(param) {
    var slug = param.slug, variants = param.variants, collectionImage = param.collectionImage, selectedVariant = param.selectedVariant, isRegionallyAvailable = param.isRegionallyAvailable, _isExpired = param.isExpired, isExpired = _isExpired === void 0 ? false : _isExpired;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var image = (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.images) === null || ref === void 0 ? void 0 : ref.length) > 0 ? (ref1 = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.images[0]) === null || ref1 === void 0 ? void 0 : ref1.responsiveImage : null;
    var isTopLeft = "false" === "true";
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.imageWrapper,
        children: [
            (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.collectionPageMainImage) ? /*#__PURE__*/ _jsx(Image, {
                className: styles.image,
                "data-test-id": "".concat(slug, "-image-link"),
                data: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref2 = selectedVariant.collectionPageMainImage) === null || ref2 === void 0 ? void 0 : ref2.responsiveImage,
                width: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref3 = selectedVariant.collectionPageMainImage) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.responsiveImage) === null || ref4 === void 0 ? void 0 : ref4.width,
                height: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref5 = selectedVariant.collectionPageMainImage) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.responsiveImage) === null || ref6 === void 0 ? void 0 : ref6.height
            }) : /*#__PURE__*/ _jsx(_Fragment, {
                children: image ? /*#__PURE__*/ _jsx(Image, {
                    className: styles.image,
                    "data-test-id": "".concat(slug, "-image-link"),
                    data: image,
                    width: image === null || image === void 0 ? void 0 : image.width,
                    height: image === null || image === void 0 ? void 0 : image.height
                }) : /*#__PURE__*/ _jsx(Image, {
                    className: styles.image,
                    "data-test-id": "".concat(slug, "-image-link"),
                    data: collectionImage === null || collectionImage === void 0 ? void 0 : collectionImage.responsiveImage,
                    width: collectionImage === null || collectionImage === void 0 ? void 0 : (ref7 = collectionImage.responsiveImage) === null || ref7 === void 0 ? void 0 : ref7.width,
                    height: collectionImage === null || collectionImage === void 0 ? void 0 : (ref8 = collectionImage.responsiveImage) === null || ref8 === void 0 ? void 0 : ref8.height
                })
            }),
            Array.isArray(variants) && variants.length > 0 && selectedVariant && /*#__PURE__*/ _jsx("div", {
                className: styles.textWrapper(isTopLeft),
                children: variants && /*#__PURE__*/ _jsx(AvailabilityMessage, {
                    isRegionallyAvailable: isRegionallyAvailable,
                    variant: selectedVariant,
                    isExpired: isExpired
                })
            })
        ]
    });
};
/* harmony default export */ var CardComponents_CardImage_CardImage = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(CardImage_CardImage))));

;// CONCATENATED MODULE: ./components/CardComponents/CardImage/index.ts


;// CONCATENATED MODULE: ./components/CardComponents/UpperCard/styles.ts


var descGrid = (0,tailwindcss_classnames/* classnames */.d)("grid", "gap-0", "grid-cols-2", "items-end", "pt-2", "justify-end");
var servicesWrapper = (0,tailwindcss_classnames/* classnames */.d)("flex", "flex-col", "justify-end");
var UpperCard_styles_smallText = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "text-nzxt-light-grey-400", "mb-1", "md:hidden", "visible", "flex-grow");
var wrapper = (0,tailwindcss_classnames/* classnames */.d)("flex", "flex-col", "h-full");
var growWrapper = (0,tailwindcss_classnames/* classnames */.d)("flex-grow", "mb-3", "mt-1");
var defaultPlacement = (0,tailwindcss_classnames/* classnames */.d)("top-10", "right-10");
var smallPlacement = (0,tailwindcss_classnames/* classnames */.d)("md:top-10", "md:right-10", "hidden", "md:block");
var quickBuyPlacement = function(isSmall) {
    var _obj;
    return classnames("absolute", "pl-4", "pb-4", "md:pl-2", "md:pb-4", (_obj = {}, _define_property(_obj, defaultPlacement, !isSmall), _define_property(_obj, smallPlacement, isSmall), _obj));
};

;// CONCATENATED MODULE: ./components/CardComponents/UpperCard/UpperCard.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 













var UpperCard_UpperCard = function(param) {
    var currencyCode = param.currencyCode, name = param.name, slug = param.slug, variants = param.variants, shortDescription = param.shortDescription, collectionImage = param.collectionImage, isNude = param.isNude, availableRegions = param.availableRegions, _isExtendedCard = param.isExtendedCard, isExtendedCard = _isExtendedCard === void 0 ? false : _isExtendedCard, _isSmall = param.isSmall, isSmall = _isSmall === void 0 ? false : _isSmall, _isCustomCard = param.isCustomCard, isCustomCard = _isCustomCard === void 0 ? false : _isCustomCard, regionalServices = param.regionalServices, eventType = param.eventType, selectedVariant = param.selectedVariant, _isExpired = param.isExpired, isExpired = _isExpired === void 0 ? false : _isExpired;
    var ref, ref1, ref2;
    var locale = useRouter().locale;
    var region = getRegion(locale);
    var isRegionallyAvailable = useMemo(function() {
        return Array.isArray(availableRegions) ? availableRegions.some(function(r) {
            return r.region === region;
        }) : false;
    }, [
        region,
        availableRegions
    ]);
    var isAvailable = !isCustomCard ? !selectedVariant.isComingSoon && !isNude && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isValid) && isRegionallyAvailable && !selectedVariant.isOutOfStock : true;
    var variantColorsTotal = Array.isArray(variants) && (variants === null || variants === void 0 ? void 0 : variants.map(function(param) {
        var color = param.color;
        return color;
    }));
    var COLORS = t("message_colors");
    var COLOR = t("message_color");
    var colorText = (variantColorsTotal === null || variantColorsTotal === void 0 ? void 0 : variantColorsTotal.length) > 1 ? "".concat(variantColorsTotal === null || variantColorsTotal === void 0 ? void 0 : variantColorsTotal.length, " ").concat(COLORS) : "".concat(variantColorsTotal === null || variantColorsTotal === void 0 ? void 0 : variantColorsTotal.length, " ").concat(COLOR);
    var ref3, ref4;
    var ecommerce = selectedVariant ? {
        click: {
            products: [
                {
                    name: name,
                    id: selectedVariant.id,
                    price: (ref3 = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.price) === null || ref === void 0 ? void 0 : ref.toString()) !== null && ref3 !== void 0 ? ref3 : null,
                    brand: "NZXT",
                    variant: (ref4 = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.color) === null || ref1 === void 0 ? void 0 : ref1.map(function(color) {
                        return color.name;
                    }).join("/")) !== null && ref4 !== void 0 ? ref4 : null
                }, 
            ]
        }
    } : null;
    var handleEvent = function() {
        if (eventType) {
            GTM.dataLayer({
                dataLayer: {
                    event: eventType,
                    interactionType: "productCard",
                    ecommerce: ecommerce
                }
            });
        }
    };
    var event = selectedVariant ? "productClick" : "clickToBuild";
    var handleLinkClick = function() {
        GTM.dataLayer({
            dataLayer: {
                event: (typeof eventType === "undefined" ? "undefined" : _type_of(eventType)) !== undefined ? eventType : event,
                ecommerce: ecommerce
            }
        });
    };
    var linkage = isCustomCard ? slug : "/".concat(ROUTE_PRODUCT, "/").concat(slug);
    var hasPromo = Boolean((regionalServices === null || regionalServices === void 0 ? void 0 : regionalServices.shippingNotices) || (regionalServices === null || regionalServices === void 0 ? void 0 : (ref2 = regionalServices.bundlesPromos) === null || ref2 === void 0 ? void 0 : ref2.length) > 0);
    var showInventory = (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.showInventoryCount) && isRegionallyAvailable && !(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isComingSoon) && !(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isOutOfStock);
    return name && slug ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isAvailable && !isExpired && /*#__PURE__*/ _jsx("div", {
                className: styles.quickBuyPlacement(isSmall),
                style: {
                    zIndex: 1
                },
                children: /*#__PURE__*/ _jsx(QuickBuy, {
                    selectedVariant: selectedVariant,
                    currencyCode: currencyCode,
                    name: name
                })
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: linkage,
                passHref: true,
                children: /*#__PURE__*/ _jsxs("a", {
                    onClick: function() {
                        return handleLinkClick();
                    },
                    onKeyDown: function() {
                        return handleLinkClick();
                    },
                    role: "link",
                    tabIndex: 0,
                    className: styles.wrapper,
                    children: [
                        /*#__PURE__*/ _jsx(CardImage, {
                            name: name,
                            slug: slug,
                            variants: variants,
                            collectionImage: collectionImage,
                            selectedVariant: selectedVariant,
                            isRegionallyAvailable: isRegionallyAvailable,
                            isAvailable: isAvailable,
                            isExpired: isExpired
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.growWrapper,
                            children: /*#__PURE__*/ _jsx(CardHeading, {
                                name: name,
                                slug: slug,
                                shortDescription: shortDescription,
                                isExtended: isExtendedCard,
                                isSmall: isSmall,
                                handleClick: handleEvent,
                                inventoryData: {
                                    showInventory: showInventory,
                                    stock: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.stock
                                }
                            })
                        }),
                        !isExtendedCard && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                hasPromo ? /*#__PURE__*/ _jsxs("div", {
                                    className: styles.servicesWrapper,
                                    children: [
                                        (regionalServices === null || regionalServices === void 0 ? void 0 : regionalServices.shippingNotices) ? /*#__PURE__*/ _jsx(CardService, {
                                            slug: slug,
                                            handleClick: handleEvent,
                                            service: regionalServices === null || regionalServices === void 0 ? void 0 : regionalServices.shippingNotices
                                        }) : null,
                                        (regionalServices === null || regionalServices === void 0 ? void 0 : regionalServices.bundlesPromos) ? /*#__PURE__*/ _jsx(CardService, {
                                            slug: slug,
                                            handleClick: handleEvent,
                                            service: regionalServices === null || regionalServices === void 0 ? void 0 : regionalServices.bundlesPromos
                                        }) : null
                                    ]
                                }) : null,
                                isSmall && /*#__PURE__*/ _jsx("p", {
                                    className: styles.smallText,
                                    children: colorText
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }) : null;
};
/* harmony default export */ var CardComponents_UpperCard_UpperCard = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(UpperCard_UpperCard))));

;// CONCATENATED MODULE: ./components/CardComponents/UpperCard/index.ts


;// CONCATENATED MODULE: ./components/CardComponents/index.ts









;// CONCATENATED MODULE: ./components/CardComponents/CountdownTimer/styles.ts

// countdown
var countdown = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-light-grey-600", "font-semibold", "text-xs", "flex", "space-x-1", "items-start", "md:items-center");
var countdownContainer = (0,tailwindcss_classnames/* classnames */.d)("flex", "col-span-2", "w-full");

;// CONCATENATED MODULE: ./components/CardComponents/CountdownTimer/CountdownTimer.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 



var CountdownTimer_CountdownTimer = function(param) {
    var countdownData = param.countdownData, customContainerClass = param.customContainerClass;
    var ref, ref1, ref2, ref3, ref4;
    var DEAL_LABEL = t("label_deal_ends");
    var timeCheck = (countdownData === null || countdownData === void 0 ? void 0 : (ref = countdownData.countdownEndDate) === null || ref === void 0 ? void 0 : ref.days) === "00";
    var stylesToShow = customContainerClass || styles.countdownContainer;
    return !(countdownData === null || countdownData === void 0 ? void 0 : (ref1 = countdownData.countdownEndDate) === null || ref1 === void 0 ? void 0 : ref1.isExpired) && timeCheck && (countdownData === null || countdownData === void 0 ? void 0 : countdownData.showCountdown) ? /*#__PURE__*/ _jsx("div", {
        className: stylesToShow,
        children: /*#__PURE__*/ _jsxs("p", {
            className: styles.countdown,
            children: [
                /*#__PURE__*/ _jsx("span", {
                    children: /*#__PURE__*/ _jsx("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        strokeWidth: 2,
                        stroke: "currentColor",
                        className: "w-4 h-4",
                        children: /*#__PURE__*/ _jsx("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
                        })
                    })
                }),
                " ",
                /*#__PURE__*/ _jsx("span", {
                    children: "".concat(DEAL_LABEL, " ").concat(countdownData === null || countdownData === void 0 ? void 0 : (ref2 = countdownData.countdownEndDate) === null || ref2 === void 0 ? void 0 : ref2.hours, ":").concat(countdownData === null || countdownData === void 0 ? void 0 : (ref3 = countdownData.countdownEndDate) === null || ref3 === void 0 ? void 0 : ref3.minutes, ":").concat(countdownData === null || countdownData === void 0 ? void 0 : (ref4 = countdownData.countdownEndDate) === null || ref4 === void 0 ? void 0 : ref4.seconds)
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var CardComponents_CountdownTimer_CountdownTimer = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(CountdownTimer_CountdownTimer))));

;// CONCATENATED MODULE: ./components/CardComponents/CountdownTimer/index.ts


;// CONCATENATED MODULE: ./components/ProductCard/styles.ts


var smallButtonText = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "md:text-base");
var buttonLabel = function(isSmall) {
    return classnames(_define_property({}, smallButtonText, isSmall));
};
var styles_descGrid = (0,tailwindcss_classnames/* classnames */.d)("grid", "gap-0", "grid-cols-2", "items-end");
var fullWidth = (0,tailwindcss_classnames/* classnames */.d)("w-full");
var borderTop = "border-t";
var extendedDetailsWrapper = function(withBorder) {
    return classnames("grid", "items-center", "mt-2", "pt-4", _define_property({}, borderTop, withBorder));
};

;// CONCATENATED MODULE: ./components/ProductCard/ProductCard.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 











var ProductCard_ProductCard = function(param) {
    var currencyCode = param.currencyCode, name = param.name, slug = param.slug, variants = param.variants, shortDescription = param.shortDescription, collectionImage = param.collectionImage, isNude = param.isNude, availableRegions = param.availableRegions, techSpecs = param.techSpecs, _isExtendedCard = param.isExtendedCard, isExtendedCard = _isExtendedCard === void 0 ? false : _isExtendedCard, _noVariantToggle = param.noVariantToggle, noVariantToggle = _noVariantToggle === void 0 ? false : _noVariantToggle, _isSmall = param.isSmall, isSmall = _isSmall === void 0 ? false : _isSmall, regionalServices = param.regionalServices, eventType = param.eventType;
    var ref, ref1, ref2, ref3;
    var locale = useRouter().locale;
    var region = getRegion(locale);
    var isRegionallyAvailable = useMemo(function() {
        return Array.isArray(availableRegions) ? availableRegions.some(function(r) {
            return r.region === region;
        }) : false;
    }, [
        region,
        availableRegions
    ]);
    var ref4 = useState(variants[0]), selectedVariant = ref4[0], setSelectedVariant = ref4[1];
    var variantsCopy = _to_consumable_array(variants);
    useEffect(function() {
        var ref;
        if (variants[0].isOutOfStock || !((ref = variants[0]) === null || ref === void 0 ? void 0 : ref.isValid)) {
            var isInStock = variantsCopy.find(function(item) {
                return !item.isOutOfStock;
            });
            var indexOfInStock = variants.indexOf(isInStock);
            var selectedIndex = indexOfInStock >= 0 ? indexOfInStock : 0;
            setSelectedVariant(variants[selectedIndex]);
        } else {
            setSelectedVariant(variants[0]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        variants
    ]);
    var techSpecsSlimmed = Array.isArray(techSpecs) && (techSpecs === null || techSpecs === void 0 ? void 0 : techSpecs.length) > 0 && Object.values((ref = techSpecs[0]) === null || ref === void 0 ? void 0 : ref.specValues).slice(0, 3);
    var techSpecsLabel = Array.isArray(techSpecs) && (techSpecs === null || techSpecs === void 0 ? void 0 : techSpecs.length) > 0 && ((ref1 = techSpecs[0]) === null || ref1 === void 0 ? void 0 : ref1.specCategory);
    var SHOP_LABEL = t("label_shop");
    var ref5, ref6;
    var ecommerce = selectedVariant ? {
        click: {
            products: [
                {
                    name: name,
                    id: selectedVariant.id,
                    price: (ref5 = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref2 = selectedVariant.price) === null || ref2 === void 0 ? void 0 : ref2.toString()) !== null && ref5 !== void 0 ? ref5 : null,
                    brand: "NZXT",
                    variant: (ref6 = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref3 = selectedVariant.color) === null || ref3 === void 0 ? void 0 : ref3.map(function(color) {
                        return color.name;
                    }).join("/")) !== null && ref6 !== void 0 ? ref6 : null
                }, 
            ]
        }
    } : null;
    var handleEvent = function() {
        if (eventType) {
            GTM.dataLayer({
                dataLayer: {
                    event: eventType,
                    interactionType: "productCard",
                    ecommerce: ecommerce
                }
            });
        }
    };
    var showCountdown = (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.showCountdownTimer) && isRegionallyAvailable && !(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isComingSoon) && !(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isOutOfStock);
    var countdownData = useCountdown(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.countdownEndDate);
    return name && slug ? /*#__PURE__*/ _jsxs(CardWrapper, {
        children: [
            /*#__PURE__*/ _jsx(UpperCard, {
                currencyCode: currencyCode,
                name: name,
                slug: slug,
                variants: variants,
                shortDescription: shortDescription,
                collectionImage: collectionImage,
                isNude: isNude,
                availableRegions: availableRegions,
                isExtendedCard: isExtendedCard,
                isSmall: isSmall,
                regionalServices: regionalServices,
                eventType: eventType,
                selectedVariant: selectedVariant,
                isExpired: showCountdown ? countdownData === null || countdownData === void 0 ? void 0 : countdownData.isExpired : false
            }),
            /*#__PURE__*/ _jsxs(CardContentWrapper, {
                children: [
                    isExtendedCard && /*#__PURE__*/ _jsx(CardExtendedDetails, {
                        extendedHeading: techSpecsLabel,
                        extendedDetails: techSpecsSlimmed
                    }),
                    !isExtendedCard && /*#__PURE__*/ _jsxs("div", {
                        className: styles.descGrid,
                        children: [
                            /*#__PURE__*/ _jsx(CardPrice, {
                                currencyCode: currencyCode,
                                slug: slug,
                                handleClick: handleEvent,
                                selectedVariant: selectedVariant,
                                isRegionallyAvailable: isRegionallyAvailable,
                                isSmall: isSmall
                            }),
                            !isNude && // eslint-disable-next-line react/jsx-no-useless-fragment
                            /*#__PURE__*/ _jsx(CardColorVariants, {
                                isRegionallyAvailable: isRegionallyAvailable,
                                variants: variants,
                                selectedVariant: selectedVariant,
                                setSelectedVariant: setSelectedVariant,
                                productName: name,
                                slug: slug,
                                handleClick: handleEvent,
                                isFaux: noVariantToggle,
                                isSmall: isSmall
                            }),
                            (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.countdownEndDate) && /*#__PURE__*/ _jsx(CountdownTimer, {
                                countdownData: {
                                    showCountdown: showCountdown,
                                    countdownEndDate: countdownData
                                }
                            })
                        ]
                    }),
                    isExtendedCard && /*#__PURE__*/ _jsxs("div", {
                        className: styles.fullWidth,
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.extendedDetailsWrapper(true),
                                children: [
                                    /*#__PURE__*/ _jsx(CardPrice, {
                                        currencyCode: currencyCode,
                                        slug: slug,
                                        handleClick: handleEvent,
                                        selectedVariant: selectedVariant,
                                        isRegionallyAvailable: isRegionallyAvailable,
                                        isSmall: isSmall
                                    }),
                                    (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.countdownEndDate) && /*#__PURE__*/ _jsx(CountdownTimer, {
                                        countdownData: {
                                            showCountdown: showCountdown,
                                            countdownEndDate: countdownData
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.extendedDetailsWrapper(false),
                                children: /*#__PURE__*/ _jsx(ButtonLink, {
                                    asButton: true,
                                    buttonStyle: "primary",
                                    href: "/".concat(ROUTE_PRODUCT, "/").concat(slug),
                                    className: styles.buttonLabel(isSmall),
                                    customMargin: true,
                                    internalLink: true,
                                    children: SHOP_LABEL
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }) : null;
};
/* harmony default export */ var components_ProductCard_ProductCard = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(ProductCard_ProductCard))));

;// CONCATENATED MODULE: ./components/ProductCard/index.ts


;// CONCATENATED MODULE: ./components/CollectionPage/CollectionList/styles.ts


var styles_wrapper = (0,tailwindcss_classnames/* classnames */.d)("grid", "gap-12", "lg:grid-cols-12", "grid-cols-1");
var listWrapper = (0,tailwindcss_classnames/* classnames */.d)("grid", "gap-12", "grid-cols-1", "md:grid-cols-2", "col-span-full", "lg:col-span-8", "justify-items-center");
var selfCenter = "self-center";
var textColumn = (0,tailwindcss_classnames/* classnames */.d)("lg:col-span-4", "col-span-full");
var composedTextColumn = function(isOneRow) {
    return classnames(textColumn, _define_property({}, selfCenter, isOneRow));
};
var styles_textWrapper = (0,tailwindcss_classnames/* classnames */.d)("max-w-xs", "flex", "flex-col", "items-center", "md:py-12", "py-4", "h-full", "text-center", "mx-auto");
var sticky = (0,tailwindcss_classnames/* classnames */.d)("md:sticky", "md:top-1/2");
var stickyText = function(isOneRow) {
    return classnames(_define_property({}, sticky, !isOneRow));
};
var CollectionList_styles_heading = (0,tailwindcss_classnames/* classnames */.d)("leading-snug", "uppercase", "text-3xl", "xl:text-4xl", "2xl:text-5xl", "mb-4", "md:mb-5", "h2");
var CollectionList_styles_subheading = (0,tailwindcss_classnames/* classnames */.d)("leading-relaxed", "text-nzxt-light-grey-800");

;// CONCATENATED MODULE: ./components/CollectionPage/CollectionList/CollectionList.tsx






var CollectionList_CollectionList = function(param) {
    var heading = param.heading, products = param.products, shortDescription = param.shortDescription, currencyCode = param.currencyCode, collectionName = param.collectionName;
    // track product impressions for GA enhanced ecommerce
    useEffect(function() {
        if (Array.isArray(products) && products.length > 0) {
            var impressions = [];
            products.forEach(function(product, i) {
                impressions.push({
                    name: product.name,
                    id: Array.isArray(product.variants) && product.variants.length > 0 ? product.variants[0].id : product.slug,
                    price: product.collectionPagePrice ? product.collectionPagePrice.toString() : null,
                    brand: "NZXT",
                    variant: Array.isArray(product.variants) && product.variants.length > 0 && Array.isArray(product.variants[0].color) ? product.variants[0].color.map(function(color) {
                        return color.name;
                    }).join("/") : null,
                    list: "".concat(collectionName, " Collection Page"),
                    position: i
                });
            });
            GTM.dataLayer({
                dataLayer: {
                    ecommerce: {
                        currencyCode: currencyCode,
                        impressions: impressions
                    }
                }
            });
        }
    }, [
        products,
        currencyCode,
        collectionName
    ]);
    var isOneRow = (products === null || products === void 0 ? void 0 : products.length) <= 2;
    var hasProducts = Array.isArray(products) && (products === null || products === void 0 ? void 0 : products.length) > 0;
    return hasProducts ? /*#__PURE__*/ _jsx(ContentWrapper, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.wrapper,
            "data-test-id": "collections-list-block",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.composedTextColumn(isOneRow),
                    children: (heading || shortDescription) && /*#__PURE__*/ _jsx("div", {
                        className: styles.textWrapper,
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: styles.stickyText(isOneRow),
                            children: [
                                heading && /*#__PURE__*/ _jsx("h2", {
                                    className: styles.heading,
                                    "data-test-id": "collections-list-heading",
                                    children: heading
                                }),
                                shortDescription && /*#__PURE__*/ _jsx("p", {
                                    className: styles.subheading,
                                    "data-test-id": "collections-list-shrt-des",
                                    children: shortDescription
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.listWrapper,
                    children: products.map(function(product) {
                        return /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(ProductCard, {
                                collectionImage: product.collectionPageMainImage,
                                name: product.name,
                                slug: product.slug,
                                variants: product.variants,
                                productPrice: product.collectionPagePrice,
                                currencyCode: currencyCode,
                                shortDescription: product.shortDescription,
                                availableRegions: product.availableRegions
                            })
                        }, product.id);
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var CollectionPage_CollectionList_CollectionList = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(CollectionList_CollectionList))));

;// CONCATENATED MODULE: ./components/CollectionPage/CollectionList/index.ts

/* harmony default export */ var CollectionPage_CollectionList = ((/* unused pure expression or super */ null && (CollectionList)));

// EXTERNAL MODULE: ./components/SectionWrapper/index.ts + 2 modules
var SectionWrapper = __webpack_require__(74871);
// EXTERNAL MODULE: ./components/IconSection/index.ts + 2 modules
var IconSection = __webpack_require__(21762);
;// CONCATENATED MODULE: ./components/CollectionPage/index.ts








// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./utils/get-from-local-storage.ts
function getFromLocalStorage(key) {
    if (true) {
        return window.localStorage.getItem(key);
    }
    return null;
}
/* harmony default export */ var get_from_local_storage = ((/* unused pure expression or super */ null && (getFromLocalStorage)));

;// CONCATENATED MODULE: ./node_modules/auto-zustand-selectors-hook/dist/index.es.js
function index_es_t(t){return t.use={},Object.keys(t.getState()).forEach((function(e){var n=function(t){return t[e]};t.use[e]=function(){return t(n)}})),t}function e(t){return t.use={},Object.keys(t.getState()).forEach((function(e){var n,r=function(t){return t[e]};t["use"+(n=e,n.charAt(0).toUpperCase()+n.slice(1))]=function(){return t(r)}})),t}
//# sourceMappingURL=index.es.js.map

;// CONCATENATED MODULE: ./node_modules/immer/dist/immer.esm.mjs
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function immer_esm_t(n){return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!n.constructor[L]||s(n)||v(n))}function immer_esm_e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?(n.delete(r),n.add(t)):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!immer_esm_t(n)?n:(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0),n)}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function O(n){g(n),n.p.forEach(S),n.p=null}function g(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.O=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.g||b("ES5").S(e,r,o),o?(i[Q].P&&(O(e),n(4)),immer_esm_t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),O(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o;i(3===e.i?new Set(o):o,(function(r,i){return A(n,e,o,r,i,t)})),x(n,o,!1),t&&n.u&&b("Patches").R(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s){if( false&&0,r(c)){var v=M(e,c,s&&i&&3!==i.i&&!u(i.D,a)?s.concat(a):void 0);if(f(o,a,v),!r(v))return;e.m=!1}if(immer_esm_t(c)&&!y(c)){if(!e.h.F&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),n.h.F&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function R(n,r,t){var e=s(r)?b("MapSet").N(r,t):v(r)?b("MapSet").T(r,t):n.g?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,D:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function D(e){return r(e)||n(22,e),function n(r){if(!immer_esm_t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=F(r,c),u.I=!1}else e=F(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function F(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function N(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.O&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,D:{},l:r,t:n,k:i,o:null,O:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.D,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!immer_esm_t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=""+i[s];0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},R:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.D,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.D,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.D=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(immer_esm_t(r)){var e=R(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.O&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,D:void 0,t:n,k:this,C:!1,O:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.D.set(n,!0),t.o.set(n,r),t.D.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.D.set(n,!1):r.D.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.D=new Map,i(n.t,(function(r){n.D.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!immer_esm_t(i))return i;if(i!==r.t.get(n))return i;var o=R(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,O:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{N:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){N(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!immer_esm_t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=R(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.D[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&"number"!=typeof t&&(void 0!==t||r in n.o)||(n.o[r]=t,n.D[r]=!0,!0)},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.D[r]=!1,E(n),k(n)):delete n.D[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.g=B,this.F=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),immer_esm_t(r)){var c=w(e),s=R(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?O(c):g(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw O(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.F&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){immer_esm_t(e)||n(8),r(e)&&(e=D(e));var i=w(this),o=R(this,e,void 0);return o[Q].C=!0,g(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.F=n},i.setUseProxies=function(r){r&&!B&&n(20),this.g=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,immer_esm_cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ var immer_esm = (fn);
//# sourceMappingURL=immer.esm.js.map

// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./stores/use-auth-store/use-auth-store.ts
/* eslint-disable no-param-reassign */ 


var useAuthStoreBase = (0,esm/* default */.Z)(function(set) {
    return {
        user: null,
        isAuthenticated: false,
        isLoading: true,
        login: function(user) {
            localStorage.setItem("token", user.token);
            set(immer_esm(function(state) {
                state.isAuthenticated = true;
                state.user = user;
            }));
        },
        logout: function() {
            localStorage.removeItem("token");
            set(immer_esm(function(state) {
                state.isAuthenticated = false;
                state.user = null;
            }));
        },
        stopLoading: function() {
            set(immer_esm(function(state) {
                state.isLoading = false;
            }));
        }
    };
});
var useAuthStore = e(useAuthStoreBase);
/* harmony default export */ var use_auth_store = (useAuthStore);

;// CONCATENATED MODULE: ./stores/use-auth-store/index.ts


;// CONCATENATED MODULE: ./components/Auth/hoc/withAuth.tsx
/* eslint-disable @typescript-eslint/explicit-function-return-type */ 









var HOME_ROUTE = "/";
var LOGIN_ROUTE = "/login";
var RouteRole;
(function(RouteRole) {
    RouteRole[RouteRole[/**
   * For authentication pages
   * @example /login /register
   */ "auth"] = 0] = "auth";
    RouteRole[RouteRole[/**
   * Optional authentication
   * It doesn't push to login page if user is not authenticated
   */ "optional"] = 1] = "optional";
    RouteRole[RouteRole[/**
   * For all authenticated user
   * will push to login if user is not authenticated
   */ "all"] = 2] = "all";
})(RouteRole || (RouteRole = {}));
/**
 * Add role-based access control to a component
 *
 * @see https://react-typescript-cheatsheet.netlify.app/docs/hoc/full_example/
 * @see https://github.com/mxthevs/nextjs-auth/blob/main/src/components/withAuth.tsx
 */ function withAuth(Component, routeRole) {
    var ComponentWithAuth = function(props) {
        var router = (0,next_router.useRouter)();
        var query = router.query;
        var isAuthenticated = use_auth_store.useIsAuthenticated();
        var isLoading = use_auth_store.useIsLoading();
        var login = use_auth_store.useLogin();
        var logout = use_auth_store.useLogout();
        var stopLoading = use_auth_store.useStopLoading();
        var user = use_auth_store.useUser();
        var checkAuth = react.useCallback(function() {
            var token = getFromLocalStorage("token");
            if (!token && isAuthenticated) {
                logout();
                stopLoading();
                return;
            }
            var loadUser = function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var res, data;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                _ctx.next = 3;
                                return fetch("/me");
                            case 3:
                                res = _ctx.sent;
                                _ctx.next = 6;
                                return res.json();
                            case 6:
                                data = _ctx.sent;
                                login((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), {
                                    token: token
                                }));
                                _ctx.next = 13;
                                break;
                            case 10:
                                _ctx.prev = 10;
                                _ctx.t0 = _ctx["catch"](0);
                                localStorage.removeItem("token");
                            case 13:
                                _ctx.prev = 13;
                                stopLoading();
                                return _ctx.finish(13);
                            case 16:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            10,
                            13,
                            16
                        ]
                    ]);
                }));
                return function loadUser() {
                    return _ref.apply(this, arguments);
                };
            }();
            if (!isAuthenticated) {
                loadUser();
            }
        }, [
            isAuthenticated,
            login,
            logout,
            stopLoading
        ]);
        react.useEffect(function() {
            // run checkAuth every page visit
            checkAuth();
            // run checkAuth every focus changes
            window.addEventListener("focus", checkAuth);
            return function() {
                window.removeEventListener("focus", checkAuth);
            };
        }, [
            checkAuth
        ]);
        react.useEffect(function() {
            if (!isLoading) {
                if (isAuthenticated) {
                    // Prevent authenticated user from accessing auth or other role pages
                    if (routeRole === "auth") {
                        if (query === null || query === void 0 ? void 0 : query.redirect) {
                            router.replace(query.redirect);
                        } else {
                            router.replace(HOME_ROUTE);
                        }
                    }
                } else if (routeRole !== "auth" && routeRole !== "optional") {
                    // Prevent unauthenticated user from accessing protected pages
                    router.replace("".concat(LOGIN_ROUTE, "?redirect=").concat(router.asPath), "".concat(LOGIN_ROUTE));
                }
            }
        }, [
            isAuthenticated,
            isLoading,
            query,
            router,
            user
        ]);
        if (// If unauthenticated user want to access protected pages
        (isLoading || !isAuthenticated) && // auth pages and optional pages are allowed to access without login
        routeRole !== "auth" && routeRole !== "optional") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "".concat((0,hooks/* useTranslation */.$G)("loading"), "...")
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            user: user
        }));
    };
    return ComponentWithAuth;
};

;// CONCATENATED MODULE: ./pages/oauth/[...slug].tsx











var Loading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLoading/* default */.Z, {
        className: "loading-icon"
    });
};
var LoginView = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7536), __webpack_require__.e(655), __webpack_require__.e(4007)]).then(__webpack_require__.bind(__webpack_require__, 68839));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68839)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {});
    }
});
var LogoutView = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4194).then(__webpack_require__.bind(__webpack_require__, 64194));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64194)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {});
    }
});
var ConsentView = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3834).then(__webpack_require__.bind(__webpack_require__, 83834));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83834)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {});
    }
});
var SignUpView = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7536), __webpack_require__.e(655), __webpack_require__.e(2861), __webpack_require__.e(4853)]).then(__webpack_require__.bind(__webpack_require__, 22861));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22861)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {});
    }
});
var ResetView = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7536), __webpack_require__.e(1666), __webpack_require__.e(5194)]).then(__webpack_require__.bind(__webpack_require__, 31666));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31666)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {});
    }
});
var ForgotView = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7536), __webpack_require__.e(7082), __webpack_require__.e(1819)]).then(__webpack_require__.bind(__webpack_require__, 57082));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57082)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {});
    }
});
var VerifyView = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4062).then(__webpack_require__.bind(__webpack_require__, 94062));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94062)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {});
    }
});
var ErrorView = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5542).then(__webpack_require__.bind(__webpack_require__, 85542));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85542)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {});
    }
});
var OAuth = function(param) {
    var baseUrl = param.baseUrl, page = param.page;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    return !page ? /*#__PURE__*/ (0,jsx_runtime.jsx)(error["default"], {
        statusCode: 404
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* default */.Z, {
                canonical: "".concat(baseUrl, "/").concat(constants/* ROUTE_OAUTH */.Ggo, "/").concat(query.slug),
                baseUrl: baseUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionWrapper/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_ContentWrapper/* default */.Z, {
                    children: [
                        page === "login" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginView, {
                            pageType: "standalone"
                        }),
                        page === "logout" && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutView, {
                            pageType: "standalone"
                        }),
                        page === "consent" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsentView, {
                            pageType: "standalone"
                        }),
                        page === "signup" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpView, {
                            pageType: "standalone"
                        }),
                        page === "reset-verification" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetView, {
                            pageType: "standalone"
                        }),
                        page === "forgot-password" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotView, {
                            pageType: "standalone"
                        }),
                        page === "email-verification" && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyView, {
                            pageType: "standalone"
                        }),
                        page === "error" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorView, {})
                    ]
                })
            })
        ]
    });
};
var OAuthPageWithAuth = withAuth(OAuth, "auth");
OAuthPageWithAuth.Layout = Layout/* default */.Z;
var __N_SSG = true;
/* harmony default export */ var _slug_ = (OAuthPageWithAuth);


/***/ }),

/***/ 14709:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"buttonStyles_btn__Lyagj","link":"buttonStyles_link__R5MiN"};

/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1570,9909,6696,9774,2888,179], function() { return __webpack_exec__(90358); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);